<template>
  <div>
    <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-6">
            <div class="float-left">
              <div class="logo-container">
                <img v-bind:src="getClientAvatar"
                     class="rounded-circle"
                     width="100"
                     height="100"
                     qid="profile-photo"
                     id="avatar"
                >
                <div class="upload-helper-home rounded-circle">
                  <label class="mr-3 upload">
                    <input type="file"
                           name="fileupload"
                           value="fileupload"
                           id="file"
                           @change="onFileChange"
                    >
                    <font-awesome-icon icon="cloud-upload-alt" class="cursor-pointer" />
                  </label>
                  <span @click="removePhoto">
                    <font-awesome-icon icon="trash-alt" class="cursor-pointer"/>
                  </span>
                </div>
              </div>
            </div>
            <div class="float-left pl-3">
              <h4 qid="p-view-page-title" class="mb-3">
                <span>
                  {{ client.name }}
                </span>
              </h4>
            </div>

          </div>

          <div class="col-md-6 text-right" qid="view-p-modified">
            <div class="mb-4">
                <span class="h6 ml-3">
                <span v-if="checkIfAdmin()"
                      class="btn btn-edit cursor-pointer"
                      qid="edit-p-button"
                      @click="showEditNameProfileModal"
                >
                  <font-awesome-icon icon="pen"/>
                </span>
              </span>
            </div>
            <div>
              <span>{{ $t('table.last_updated') }}</span>
              <span class="ml-2 text-muted small" qid="view-p-modified-date">
                {{ client.updated_at | formatDate }}
              </span>
              <Avatar v-if="client.updated_by" :object="client.updated_by" size="xs" class="ml-3 mr-2"></Avatar>
              <span v-if="client.updated_by" qid="view-p-modified-by">
                {{ client.updated_by.name }}
              </span>
            </div>
          </div>

        </div>
      </div>
    </div>

    <b-tabs class="mt-3" v-model="tabIndex">

      <!-- Basic info -->
      <b-tab :title="$t('profile.client.tab.basic_info')" active>

        <b-tabs class="menu-smaller">

          <b-tab :title="$t('profile.client.tab.address')" class="mt-3">
            <div class="card">
              <div class="card-header">
                <span v-if="checkIfAdmin()"
                      class="btn btn-edit cursor-pointer float-right"
                      qid="edit-p-button"
                      @click="showFormFunction"
                >
                  <font-awesome-icon icon="pen"/>
                </span>
                <div class="float-left">
                  <h5 class="mb-2">
                    {{ $t('profile.client.address_label') }}
                  </h5>
                </div>
              </div>


              <div class="row no-gutters">
                <div class="col-sm-2 card-menu">
                  <div class="card-body text-dark pb-0">
                    <p>{{ $t('administration.clients.create.street_label') }}</p>
                    <br>
                  </div>
                </div>
                <div class="col-sm-10">
                  <div class="card-body pb-0">
                    <div class="mw-500" v-if="showForm">
                      <b-form-input
                        qid="create-client-form-street"
                        type="text"
                        v-model="clientForm.street"
                        :placeholder="$t('administration.clients.create.street_label')"
                      ></b-form-input>
                    </div>
                    <div v-if="!showForm">
                      <p>{{ client.street }}</p>
                      <br>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row no-gutters">
                <div class="col-sm-2 card-menu">
                  <div class="card-body text-dark pb-0">
                    <p>{{ $t('administration.clients.create.postcode_label') }}</p>
                    <br>
                  </div>
                </div>
                <div class="col-sm-10">
                  <div class="card-body pb-0">
                    <div class="mw-500" v-if="showForm">
                      <b-form-input
                        qid="create-client-form-postcode"
                        type="text"
                        v-model="clientForm.postcode"
                        :placeholder="$t('administration.clients.create.postcode_label')"
                      ></b-form-input>
                    </div>
                    <div v-if="!showForm">
                      <p>{{ client.postcode }}</p>
                      <br>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row no-gutters">
                <div class="col-sm-2 card-menu">
                  <div class="card-body text-dark pb-0">
                    <p>{{ $t('administration.clients.create.city_label') }}</p>
                    <br>
                  </div>
                </div>
                <div class="col-sm-10">
                  <div class="card-body pb-0">
                    <div class="mw-500" v-if="showForm">
                      <b-form-input
                        qid="create-clients-form-city"
                        type="text"
                        v-model="clientForm.city"
                        :placeholder="$t('administration.clients.create.city_label')"
                      ></b-form-input>
                    </div>
                    <div v-if="!showForm">
                      <p>{{ client.city }}</p>
                      <br>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row no-gutters">
                <div class="col-sm-2 card-menu">
                  <div class="card-body text-dark pb-0">
                    <p>{{ $t('administration.clients.create.state_label') }}</p>
                    <br>
                  </div>
                </div>
                <div class="col-sm-10">
                  <div class="card-body pb-0">
                    <div class="mw-500" v-if="showForm">
                      <b-form-input
                        qid="create-clients-form-state"
                        type="text"
                        v-model="clientForm.state"
                        :placeholder="$t('administration.clients.create.state_label')"
                      ></b-form-input>
                    </div>
                    <div v-if="!showForm">
                      <p>{{ client.state }}</p>
                      <br>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row no-gutters">
                <div class="col-sm-2 card-menu">
                  <div class="card-body text-dark pb-0">
                    <p>{{ $t('administration.clients.create.country_label') }}</p>
                    <br>
                  </div>
                </div>
                <div class="col-sm-10">
                  <div class="card-body pb-0">
                    <div class="mw-500" v-if="showForm">
                      <b-form-group>
                        <div class="row">
                          <div class="col-md-12">
                            <multiselect
                                v-model="selectedCountry"
                                :options="countries"
                                :multiple="false"
                                :taggable="false"
                                track-by="name"
                                :select-label="$t('system.dropdown_select_label')"
                                :selected-label="$t('system.dropdown_selected_label')"
                                :deselect-label="$t('system.dropdown_deselect_label')"
                                :placeholder="$t('administration.clients.create.country_label')"
                                label="name"
                                qid="create-tp-countries-select"
                            >
                              <template slot="singleLabel" slot-scope="props">
                                <img v-bind:src="props.option.flag" height="13" class="align-baseline mr-1" />
                                <span class="ml-2">
                                  {{ props.option.name }}
                                </span>
                              </template>
                              <template slot="option" slot-scope="props">
                                <img v-bind:src="props.option.flag" height="13" class="align-baseline mr-1" />
                                <span class="ml-2">
                                  {{ props.option.name }}
                                </span>
                              </template>
                            </multiselect>
                          </div>
                        </div>
                      </b-form-group>
                    </div>
                    <div v-if="!showForm">
                      <p>
                        <img v-bind:src="client.country_with_flag.flag" height="13" class="align-baseline mr-1" v-if="client && client.country_with_flag"/>
                        {{ client.country }}
                      </p>
                      <br>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row no-gutters">
                <div class="col-sm-2 card-menu">
                  <div class="card-body text-dark pb-0">
                    <p>{{ $t('administration.clients.create.cvr_label') }}</p>
                    <br>
                  </div>
                </div>
                <div class="col-sm-10">
                  <div class="card-body pb-0">
                    <div class="mw-500" v-if="showForm">
                      <b-form-input
                        qid="create-client-form-cvr"
                        type="text"
                        v-model="clientForm.cvr"
                        :placeholder="$t('administration.clients.create.cvr_label')"
                      ></b-form-input>
                    </div>
                    <div v-if="!showForm">
                      <p class="mt-2">{{ client.cvr }}</p>
                      <br>
                    </div>
                  </div>
                </div>
              </div>



              <div class="row no-gutters">
                <div class="col-sm-2 card-menu">
                  <div class="card-body text-dark pb-0">
                    <p>{{ $t('administration.partitions.create.reference_label') }}</p>
                    <br>
                  </div>
                </div>
                <div class="col-sm-10">
                  <div class="card-body pb-0">
                    <div class="mw-500" v-if="showForm">
                      <b-form-input
                        qid="create-client-form-cvr"
                        type="text"
                        v-model="clientForm.reference_number"
                        :placeholder="$t('administration.partitions.create.reference_label')"
                      ></b-form-input>


                    </div>
                    <div v-if="!showForm">
                      <p class="mt-2">{{ client.reference_number }}</p>
                      <br>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row no-gutters ">
                <div class="col-sm-2 card-menu">
                  <div class="card-body text-dark pb-0">
                    <p>{{ $t('administration.partitions.create.website_label') }}</p>
                    <br>
                  </div>
                </div>
                <div class="col-sm-10">
                  <div class="card-body pb-0">
                    <div class="mw-500" v-if="showForm">
                      <b-form-input
                              qid="create-client-form-cvr"
                              type="text"
                              v-model="clientForm.website"
                              :placeholder="$t('administration.partitions.create.website_label')"
                      ></b-form-input>
                      <b-alert v-if="clientForm.error && clientForm.error.length"
                               show
                               variant="danger"
                               qid="edit-user-error"
                               class="mt-4"
                      >
                        {{ clientForm.error }}
                      </b-alert>

                      <div class="text-right pb-3">
                        <b-button class="mt-3"
                                  variant="secondary"
                                  @click="hideFormFunction"
                                  qid="integrity-edit-cancel-button"
                        >
                          {{ $t('activities.integrity_check.cancel') }}
                        </b-button>
                        <b-button class="mt-3 ml-3"
                                  variant="success"
                                  @click="clientFormSubmit"
                                  qid="integrity-edit-submit-button"
                        >
                          {{ $t('activities.integrity_check.submit') }}
                        </b-button>
                      </div>
                    </div>
                    <div v-if="!showForm">
                      <p class="mt-2">{{ client.website }}</p>
                      <br>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </b-tab>

        </b-tabs>

      </b-tab>


      <!-- Billing tab -->
      <b-tab :title="$t('profile.client.tab.billing')" v-if="!client.parent">

        <b-tabs class="menu-smaller">
          <b-tab :title="$t('profile.client.tab.plan')" class="mt-3">
            <div class="card">
              <div class="card-body">
                <h5>
                  <!--<span class="btn btn-success cursor-pointer float-right" @click="showCartModal(client.plan)" v-if="client.plan && client.plan.name && !client.onTrial">-->
                    <!--{{ $t('profile.client.billing.upgrade_plan_button') }}-->
                  <!--</span>-->
                  {{ $t('profile.client.billing.current_plan_title') }}
                </h5>
                <h5>
                  <span v-if="client.plan">
                    <span v-if="client.plan.name && client.plan.name == 'Article 30 package'">
                      <font-awesome-icon style="color:#124A4E;" class="mr-2" icon="rocket" size="lg" />
                      {{ client.plan.name }}
                      <span v-if="client.subscription_status == 'trial' || client.subscription_status == 'trial_expired'">({{ $t('profile.client.billing.free_trial_label') }})</span>
                    </span>
                    <span v-if="client.plan.name && client.plan.name == 'Privacy package'">
                      <font-awesome-icon style="color:#124A4E;" class="mr-2" icon="space-shuttle" size="lg" />
                      {{ client.plan.name }}
                    </span>
                    <span v-if="client.plan == 'Enterprise'">
                      <font-awesome-icon style="color:#124A4E;" class="mr-2" icon="starship" size="lg" />
                      {{ client.plan }}
                    </span>
                  </span>
                </h5>
                <span class="text-normal" v-if="client.subscription_status == 'trial'">{{ $t('profile.client.billing.expires_on') }} {{client.trial_ends_at | formatDate}}</span>
                <span class="text-normal" v-if="client.subscription_status == 'trial_expired'">{{ $t('profile.client.billing.expired_at') }} {{client.trial_ends_at | formatDate}}</span>
                <span class="text-normal" v-if="client.subscription_status == 'subscription'">
                    {{ $t('profile.client.billing.activated_on') }} {{client.subscription.created_at | formatDate}}
                </span>
                <span class="text-normal" v-if="client.subscription_status == 'subscription_canceled'">{{ $t('profile.client.billing.expires_on') }} {{client.subscription.ends_at | formatDate}}</span>
                <span class="text-normal" v-if="client.subscription_status == 'subscription_ended'">{{ $t('profile.client.billing.ended_at') }} {{client.subscription.ends_at | formatDate}}</span>


                <div class="mt-3 mb-1" v-if="client.subscription_status != 'trial_expired' && client.subscription_status != 'subscription_ended'">
                  <span for="">{{ $t('profile.client.billing.owned_features') }}:</span>
                </div>

                <div class="row" style="max-width:1200px"  v-if="client.subscription_status != 'trial_expired' && client.subscription_status != 'subscription_ended'">
                  <div class="col-sm-6 col-md-6 col-lg-4 mt-2" v-for="feature in client.features">
                    <div class="row">
                      <div class="col-md-1">
                        <font-awesome-icon class="text-success mr-2" icon="check" size="lg" />
                      </div>
                      <div class="col-md-11">
                        <span class="text-normal">
                          {{ feature.name }}
                        </span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="text-muted offset-md-1 col-md-10">
                        <span v-if="client.subscription_status == 'subscription' && (feature.module == 'admin' || feature.module == 'member' || feature.module == 'validator' || feature.module == 'partition') && !client.onTrial"
                              @click="showFeatureConfirmSubscriptionModal(feature)"
                              class="billing-subscribe-button"
                        >
                          {{ $t('profile.client.billing.update') }}
                        </span>
                        <span v-if="feature.type == 'plan' && (feature.module != 'admin' && feature.module != 'member' && feature.module != 'validator' && feature.module != 'partition')">
                          {{ $t('profile.client.billing.from_plan') }}
                        </span>
                        <span v-if="feature.type == 'subscription' && (feature.module != 'admin' && feature.module != 'member' && feature.module != 'validator' && feature.module != 'partition')"
                              @click="showFeatureConfirmDeleteModal(feature)"
                              class="billing-unsubscribe-button"
                        >
                          {{ $t('profile.client.billing.unsubscribe_label') }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="client.subscription_status == 'enterprise'">
                  <div class="mt-3 mb-1"  v-if="client.missing_features && client.missing_features.length > 4">
                    <span for="">{{ $t('profile.client.billing.missing_features') }}:</span>
                  </div>
                </div>

                <div v-if="client.subscription_status != 'enterprise'">
                  <div class="mt-3 mb-1"  v-if="client.missing_features && client.missing_features.length > 0 && client.subscription_status != 'trial_expired' && client.subscription_status != 'subscription_ended' && client.subscription_status != 'trial'">
                    <span for="">{{ $t('profile.client.billing.missing_features') }}:</span>
                  </div>
                </div>

                <div v-if="client.subscription_status == 'enterprise' && client.missing_features && client.missing_features.length > 0">
                  <div class="row" style="max-width:1200px">
                    <div class="col-sm-6 col-md-6 col-lg-4 mt-2" v-for="feature in client.missing_features" v-if="feature.module != 'admin' && feature.module != 'member' && feature.module != 'validator' && feature.module != 'partition'">
                      <div class="row">
                        <div class="col-md-1">
                          <font-awesome-icon class="text-dark mr-2" icon="times" size="lg" />
                        </div>
                        <div class="col-md-11">
                          <span class="text-normal">
                            {{ feature.name }}
                          </span>
                        </div>
                      </div>
                      <div class="row" v-if="client.subscription_status == 'subscription'">
                        <div class="text-muted offset-md-1 col-md-10">
                          <span @click="showFeatureConfirmSubscriptionModal(feature)" class="billing-subscribe-button">
                            {{ $t('profile.client.billing.read_more') }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="client.subscription_status != 'enterprise' && client.missing_features && client.missing_features.length">
                  <div class="row" style="max-width:1200px" v-if="client.subscription_status != 'trial_expired' && client.subscription_status != 'subscription_ended' && client.subscription_status != 'trial'">
                    <div class="col-sm-6 col-md-6 col-lg-4 mt-2" v-for="feature in client.missing_features">
                      <div class="row">
                        <div class="col-md-1">
                          <font-awesome-icon class="text-dark mr-2" icon="times" size="lg" />
                        </div>
                        <div class="col-md-11">
                          <span class="text-normal">
                            {{ feature.name }}
                          </span>
                        </div>
                      </div>
                      <div class="row" v-if="client.subscription_status == 'subscription'">
                        <div class="text-muted offset-md-1 col-md-10">
                          <span @click="showFeatureConfirmSubscriptionModal(feature)" class="billing-subscribe-button">
                            {{ $t('profile.client.billing.read_more') }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>


            <!-- Packages  -->
            <div class="card mt-3" v-if="client && client.plan && client.subscription_status != 'enterprise'">
              <div class="card-body">
                <h5>{{ $t('profile.client.billing.packages_title') }}</h5>

                <div class="row mt-2" style="max-width:1200px">

                  <div class="col-sm-12 col-md-6 col-lg-4" v-for="(plan, index) in plans">
                    <!-- First two cards -->
                    <div class="alert-feature card-shadow" :class="{'alert-feature-active': client.subscription_status == 'subscription' &&  plan.name == client.plan.name}">
                      <h5>
                        <font-awesome-icon style="color:#124A4E;" class="mr-2" icon="rocket" size="lg" v-if="index == 0" />
                        <font-awesome-icon style="color:#124A4E;" class="mr-2" icon="space-shuttle" size="lg" v-if="index == 1" />
                        {{ plan.name }}
                      </h5>
                      <div class="mt-3" style="min-height:51px;">
                        <span class="text-normal" v-if="index == 0">
                          {{ $t('profile.client.billing.article_30_description') }}
                        </span>
                        <span class="text-normal" v-if="index == 1">
                          {{ $t('profile.client.billing.privacy_description') }}
                        </span>
                      </div>
                      <div class="mt-3">
                        <span class="text-muted">
                          {{ $t('system.from') }}
                        </span>
                      </div>
                      <div class="mt-1">
                        <h5 class="mb-1">&euro; {{ plan.price }}</h5>
                        <span class="text-muted" v-if="client.subscription_status != 'enterprise'">
                          {{ $t('profile.client.billing.per_month') }}
                        </span>
                        <span class="text-muted" v-if="client.subscription_status == 'enterprise'">
                          {{ $t('system.from') }}
                        </span>
                      </div>
                      <div class="mt-3">
                        <span class="btn btn-disabled btn-block cursor-pointer" v-if="plan.name == client.plan.name && client.subscription_status == 'subscription'">
                          <span>
                            {{ $t('profile.client.billing.current_plan_button') }}
                          </span>
                        </span>
                        <span class="btn btn-success btn-block cursor-pointer" @click="showResume(plan)" v-else-if="plan.name == client.plan.name && client.subscription_status == 'subscription_canceled'">
                          <span>
                            {{ $t('profile.client.billing.resume_plan_button') }}
                          </span>
                        </span>
                        <span class="btn btn-success btn-block cursor-pointer" @click="showCartModal(plan)" v-else>
                          <span>
                            {{ $t('profile.client.billing.select_plan_button') }}
                          </span>
                        </span>
                      </div>
                      <div class="mt-1 text-center" v-if="plan.name == client.plan.name && client.subscription_status == 'subscription'" @click="showUnsubscribe()">
                        <span class="billing-unsubscribe-button">
                          {{ $t('profile.client.billing.unsubscribe_label') }}
                        </span>
                      </div>
                      <div class="mt-4 mb-1">
                        <span for="">{{ $t('profile.client.billing.includes') }}:</span>
                      </div>
                      <div class="mt-2" v-if="feature.module != 'admin'" v-for="feature in plan.features">
                        <font-awesome-icon class="text-success mr-2" icon="check" size="lg" />
                        <span class="text-normal">
                          {{ feature.name }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-4">
                    <!-- Third card -->
                    <div class="alert-feature card-shadow mr-3 float-left">
                      <h5>
                        <font-awesome-icon style="color:#124A4E;" class="mr-2" icon="starship" size="lg" />
                        {{ $t('profile.client.billing.enterprise_plan_title') }}
                      </h5>
                      <div class="mt-3" style="min-height:51px;">
                        <span class="text-normal">
                          {{ $t('profile.client.billing.enterprise_plan_description') }}
                        </span>
                      </div>
                      <div class="mt-3">
                        <span class="text-muted">
                          {{ $t('system.from') }}
                        </span>
                      </div>
                      <div class="mt-1">
                        <h5 class="mb-1">&euro; 999</h5>
                        <span class="text-muted">
                          {{ $t('profile.client.billing.per_month') }}
                        </span>
                      </div>
                      <div class="mt-3">
                        <span class="btn btn-success btn-block cursor-pointer" v-if="!checkAdmin(permissions.ROLE_SUPER_ADMIN)" @click="goToContactPage()">
                          {{ $t('profile.client.billing.contact_us_label') }}
                        </span>
                        <span class="btn btn-success btn-block cursor-pointer" v-if="checkAdmin(permissions.ROLE_SUPER_ADMIN)" @click="showConfirmEnterpriseModal(client)">
                          {{ $t('profile.client.billing.select_plan_button') }}
                        </span>
                      </div>
                      <div class="mt-4 mb-1">
                        <span for="">{{ $t('profile.client.billing.combine_package_info') }}</span>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

          </b-tab>
          <b-tab :title="$t('profile.client.tab.payments')" class="mt-3" v-if="client.subscription_status != 'enterprise'">
            <div class="card">
              <div class="card-body">
                <h5>
                  {{ $t('profile.client.billing.payments_title') }}
                </h5>
                <div>
                  <table class="table table-responsive-md table-list-secondary">
                    <thead>
                    <tr>
                      <th scope="col">
                        {{ $t('system.number') }}
                      </th>
                      <th scope="col">
                        {{ $t('system.date') }}
                      </th>
                      <th scope="col">
                        {{ $t('system.total') }}
                      </th>
                      <th scope="col">
                        {{ $t('system.status') }}
                      </th>
                      <th width="130"></th>
                    </tr>
                    </thead>
                    <tbody>
                      <tr v-for="invoice in invoices">
                        <td>
                          <a :href="invoice.invoice_pdf">{{ invoice.number }}</a>
                        </td>
                        <td>
                          {{ invoice.status_transitions.paid_at | timestamp}}
                        </td>
                        <td>
                          &euro; {{ invoice.total / 100 }}
                        </td>
                        <td>
                          {{ invoice.status | capitalize }}
                        </td>
                        <td>
                          <a class="btn btn-secondary-dark float-right" :href="invoice.invoice_pdf">
                            <font-awesome-icon icon="file-download"/>
                          </a>
                        </td>
                      </tr>
                      <tr v-if="!loadingInvoices && !invoices.length" class="text-center">
                        <td colspan="10">
                          <h5 class="mt-3">
                            {{ $t('system.no_results') }}
                          </h5>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </b-tab>
        </b-tabs>

      </b-tab>


      <b-tab :title="$t('profile.client.tab.preferences')">

        <b-tabs class="menu-smaller">

          <!-- Email notification tab -->
          <b-tab :title="$t('profile.client.tab.notification')" active class="mt-3">

            <div class="card">
              <div class="card-header">
                <div class="float-left">
                  <h5 class="mb-2">
                    {{ $t('profile.client.notification_settings_label') }}
                  </h5>
                </div>
              </div>
              <div class="row no-gutters">
                <div class="col-sm-2 card-menu">
                  <div class="card-body text-dark">
                    <p class="mt-2">{{ $t('administration.clients.create.notification_label') }}</p>
                    <br>
                  </div>
                </div>
                <div class="col-sm-10">
                  <div class="card-body">
                    <div v-if="client.notification">
                      <div class="fs-1-5 float-left" @click="notificationSwitch(0)">
                        <font-awesome-icon class="text-success cursor-pointer" icon="toggle-on" />
                      </div>
                      &nbsp;
                      <div class="float-left switch-label">
                        {{ $t('system.enabled') }}
                      </div>
                    </div>
                    <div v-if="!client.notification">
                      <div class="fs-1-5 float-left" @click="notificationSwitch(1)">
                        <font-awesome-icon class="text-danger cursor-pointer fa-rotate-180" icon="toggle-on" />
                      </div>
                      &nbsp;
                      <div class="float-left switch-label">
                        {{ $t('system.disabled') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </b-tab>

          <b-tab :title="$t('profile.client.access_management')" class="mt-3" v-if="client.subscription_status == 'enterprise'">

            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-sm-6">
                    <div class="float-left">
                      <h5 class="mb-2" qid="questions-table-title">
                        {{ $t('profile.client.domain_access') }}
                      </h5>
                    </div>

                  </div>
                  <div class="col-sm-6 text-right">
                    <button class="btn btn-success ml-3 pl-3 pr-3"
                            @click="showCreateDomainModal()"
                            qid="question-create-button"
                            v-if="checkIfAdmin()"
                    >
                      <font-awesome-icon icon="plus"/> {{ $t('profile.client.domain_create_button') }}
                    </button>
                  </div>
                </div>

                <table class="table table-responsive-md table-drag-and-drop">
                  <thead>
                    <tr>
                      <th scope="col">
                        {{ $t('profile.client.domain_label') }}
                      </th>
                      <th scope="col">
                        {{ $t('system.last_updated') }}
                      </th>
                      <th width="180"></th>
                    </tr>
                  </thead>
                  <tr v-for="object in domainTableItems" :key="object.id">
                    <td>
                      <span v-if="object && object.domain">
                        {{ object.domain }}
                      </span>
                    </td>
                    <td>
                      <span class="text-normal">
                        {{ object.updated_at | formatDate }}
                      </span>
                    </td>
                    <td class="text-right">
                      <span class="btn btn-edit"
                            qid="edit-v-modal"
                            @click="showEditDomainModal(object)"
                            v-if="checkIfAdmin()"
                      >
                        <font-awesome-icon icon="pen"/>
                      </span>
                      <button class="btn btn-delete"
                              qid="delete-question-modal"
                              @click="showDomainConfirmDeleteModal(object)"
                              v-if="checkIfAdmin()"
                      >
                        <font-awesome-icon icon="trash-alt" />
                      </button>
                    </td>
                  </tr>
                  <tr v-if="!loading && !domainTableItems.length" qid="no-results-row-rr" class="text-center">
                    <td colspan="10">
                      <h5 class="mt-3">
                        {{ $t('system.no_results') }}
                      </h5>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </b-tab>

          <!-- Risk settings tab -->
          <b-tab :title="$t('profile.client.tab.risk_settings')" v-if="!client.parent && client.riskModule" class="mt-3">
            <div class="card">
              <div class="card-header">
                <span class="float-right" v-if="!showRiskForm">
                  <div class="text-right">
                    <span class="btn btn-edit cursor-pointer"
                          @click="showRiskFormFunction"
                          qid="process-description-cancel-button"
                          v-if="checkIfAdmin()"
                    >
                      <font-awesome-icon icon="pen"/>
                    </span>
                  </div>
                </span>
                <div class="float-left">
                  <h5 class="mb-2">
                    {{ $t('profile.client.risk_settings_label') }}
                  </h5>
                </div>
              </div>
              <div class="row no-gutters">
                <div class="col-sm-2 card-menu">
                  <div class="card-body text-dark">
                    <p class="mt-2">{{ $t('profile.client.risk_type_label') }}</p>
                    <br>
                  </div>
                </div>
                <div class="col-sm-10">
                  <div class="card-body">
                    <div class="mw-600">
                      <div v-if="showRiskForm" class="row">
                        <div class="col-sm-8">
                          <multiselect
                              v-model="selectedRiskType"
                              :options="riskTypeOptions"
                              :select-label="$t('system.dropdown_select_label')"
                              :selected-label="$t('system.dropdown_selected_label')"
                              track-by="value"
                              label="name"
                              :placeholder="$t('profile.client.risk_type_placeholder')"
                              :deselect-label="$t('profile.client.risk_settings_deselect')"
                              :allow-empty="false"
                          ></multiselect>
                        </div>
                        <div class="col-sm-4">
                          <span class="float-right" v-if="showRiskForm">
                            <div class="text-right">
                              <b-button class="btn-sm"
                                        variant="secondary"
                                        @click="cancelRiskForm"
                                        qid="cancel-button"
                              >
                                {{ $t('processes.legal_basis.create.cancel') }}
                              </b-button>
                              <b-button class="ml-3 btn-sm"
                                        variant="success"
                                        @click="formRiskTypeSubmit"
                                        qid="submit-button"
                              >
                                {{ $t('processes.legal_basis.create.submit') }}
                              </b-button>
                            </div>
                          </span>
                        </div>
                      </div>
                      <div v-if="!showRiskForm" class="row">
                        <div class="col-sm-12">
                          <p v-if="client.risk_type" class="mt-2">
                            {{ $t('profile.client.' + client.risk_type) }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-tab>

          <!-- Dashboard tab -->
          <b-tab :title="$t('profile.client.advanced_reporting')" v-if="client.advancedReportingModule" class="mt-3">
            <div class="card">
              <div class="card-body">
                <div class="content-view-body row">
                  <div class="col-md-12">
                    <div class="mt-3 p-2">
                      <p class="">
                        {{ $t('profile.client.access_token') }}
                        <span class="float-right">
                          <div class="text-right">
                            <b-button class="btn-sm inline-edit-button"
                                      variant="success"
                                      @click="showRefreshClientModal(client)"
                                      qid="process-description-cancel-button"
                            >
                              {{ $t('system.generate_token') }}
                            </b-button>
                          </div>
                        </span>
                      </p>
                      <hr>
                      <div class="row">

                        <div class="col-sm-8">
                          <h6 v-if="client.api_access_token" class="pt-3">
                            {{ client.api_access_token }}
                          </h6>
                        </div>
                        <div class="col-sm-4 pt-3">
                          <span class="float-right">
                            <span class="btn btn-light text-muted mr-3 cursor-pointer" qid="clients-edit-button" @click="showRefreshClientModal(client)">
                              <font-awesome-icon icon="redo-alt" />
                            </span>
                            <span class="btn btn-light text-muted cursor-pointer" qid="clients-delete-button" @click="showConfirmDeleteModal(client)">
                              <font-awesome-icon icon="trash-alt" />
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card mt-3">
              <div class="card-body">
                <div class="row">
                  <div class="col-sm-6">
                    <div class="float-left">
                      <h5 class="mb-2" qid="questions-table-title">
                        {{ $t('profile.client.power_bi_configuration') }}
                      </h5>
                    </div>

                  </div>
                  <div class="col-sm-6 text-right">

                    <button class="btn btn-success ml-3 pl-3 pr-3"
                            @click="showCreateReportModal()"
                            qid="question-create-button"
                            v-if="checkIfAdmin()"
                    >
                      <font-awesome-icon icon="plus"/> {{ $t('profile.client.report_create_button') }}
                    </button>
                  </div>
                </div>

                <table class="table table-responsive-md table-drag-and-drop">
                  <thead>
                    <tr>
                      <th scope="col" width="50">

                      </th>
                      <th scope="col" width="400">
                        {{ $t('profile.client.table.name') }}
                      </th>
                      <th scope="col">
                        {{ $t('profile.client.table.ctid') }}
                      </th>
                      <th scope="col">
                        {{ $t('profile.client.table.report_id') }}
                      </th>
                      <th scope="col">
                        {{ $t('profile.client.table.page_name') }}
                      </th>
                      <th width="130"></th>
                    </tr>
                  </thead>
                  <draggable v-model="tableItems" :force-fallback="true" @start="drag=true" @end="drag=false" tag="tbody" @change="postOrder">
                    <tr v-for="object in tableItems" :key="object.id">
                      <td style="cursor: move;" class="text-center" width="50">
                        <font-awesome-icon icon="arrows-alt" />
                      </td>
                      <td width="400">
                        <span v-if="object && object.name">
                          {{ object.name }}
                        </span>
                      </td>
                      <td>
                        <span v-if="object.ctid">
                          {{ object.ctid }}
                        </span>
                      </td>
                      <td>
                        <span v-if="object.report_id">
                          {{ object.report_id }}
                        </span>
                      </td>
                      <td>
                        <span v-if="object.page_name">
                          {{ object.page_name }}
                        </span>
                      </td>
                      <td class="text-right">
                        <span class="btn btn-edit"
                              qid="edit-v-modal"
                              @click="showEditReportModal(object)"
                              v-if="checkIfAdmin()"
                        >
                          <font-awesome-icon icon="pen"/>
                        </span>
                        <button class="btn btn-delete"
                                qid="delete-question-modal"
                                @click="showReportConfirmDeleteModal(object)"
                                v-if="checkIfAdmin()"
                        >
                          <font-awesome-icon icon="trash-alt" />
                        </button>
                      </td>
                    </tr>
                    <tr v-if="!loading && !tableItems.length" qid="no-results-row-rr" class="text-center">
                      <td colspan="10">
                        <h5 class="mt-3">
                          {{ $t('system.no_results') }}
                        </h5>
                      </td>
                    </tr>
                  </draggable>
                </table>
              </div>

            </div>
          </b-tab>

        </b-tabs>

      </b-tab>


    </b-tabs>

    <!-- Select enterprise package -->
    <b-modal ref="enterprise-client" hide-footer>
      <div class="d-block text-center">
        <h4 qid="delete-client-title">
          {{ $t('administration.clients.enterprise.title') }}
        </h4>
      </div>
      <h5 class="text-center">
        {{ $t('administration.clients.enterprise.description') }} {{ itemToEnterprise.name }}
      </h5>
      <h5 class="text-center">
        {{ $t('administration.clients.enterprise.are_you_sure') }}
      </h5>
      <div class="text-center">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideConfirmEnterpriseModal"
                  qid="delete-client-cancel-button"
        >
          {{ $t('administration.clients.enterprise.cancel') }}
        </b-button>
        <b-button @click="confirmEnterpriseClient(itemToEnterprise)"
                  class="mt-3 ml-3"
                  variant="success"
                  qid="delete-client-submit-button"
        >
          {{ $t('administration.clients.enterprise.submit') }}
        </b-button>
      </div>
    </b-modal>

    <!-- Edit client name profile -->
    <b-modal ref="edit-profile-name" hide-footer>
      <div class="d-block text-center">
        <h4 qid="edit-profile-modal-title">
          <h4 qid="edit-profile-modal-title">
            <span v-if="client.parent">
              {{ $t('profile.client.edit_partition_name_title') }}
            </span>
            <span v-if="!client.parent">
              {{ $t('profile.client.edit_client_name_title') }}
            </span>
          </h4>
        </h4>
      </div>
      <b-alert v-if="clientForm.error && clientForm.error.length"
               show
               variant="danger"
               qid="edit-user-error"
      >
        {{ clientForm.error }}
      </b-alert>
      <b-form @submit="clientNameFormSubmit" qid="login-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-client-name-label">
              {{ $t('administration.clients.create.name_label') }}
            </label>
            <b-form-input
              qid="create-user-form-name"
              type="text"
              v-model="clientForm.name"
              required
              :placeholder="$t('administration.clients.create.name_placeholder')"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideEditNameProfileModal"
                    qid="edit-profile-cancel-button"
          >
            {{ $t('profile.password.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    variant="success"
                    :disabled="buttonDisabled"
                    qid="edit-profile-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('profile.password.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>


    <!-- Refresh client token confirm modal template -->
    <b-modal ref="refresh-client" hide-footer>
      <div class="d-block text-center">
        <h4 qid="delete-client-title">
          {{ $t('administration.clients.refresh.title') }}
        </h4>
      </div>
      <h5 class="text-center">
        {{ $t('administration.clients.refresh.token_description') }} {{ itemToRefresh.name }}
      </h5>
      <h5 class="text-center">
        {{ $t('administration.clients.delete.are_you_sure') }}
      </h5>
      <div class="text-center">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideRefreshClientModal"
                  qid="delete-client-cancel-button"
        >
          {{ $t('administration.clients.delete.cancel') }}
        </b-button>
        <b-button @click="confirmRefreshClient(itemToRefresh)"
                  class="mt-3 ml-3"
                  variant="success"
                  qid="delete-client-submit-button"
        >
          {{ $t('administration.clients.delete.submit') }}
        </b-button>
      </div>
    </b-modal>


    <!-- Client token confirm modal template -->
    <b-modal ref="client-token" hide-footer>
      <div class="d-block text-center">
        <h4 qid="delete-client-title">
          {{ $t('administration.clients.token.title') }}
        </h4>
      </div>
      <p class="text-formatted">
        {{ $t('administration.clients.token.description') }}
      </p>
      <div class="row mt-4">
        <div class="col-md-10">{{ $t('administration.clients.token.title') }}</div>
        <div class="col-md-12 mt-2">{{ selectedToken }}</div>
      </div>
      <div class="text-center">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideClientTokenModal"
                  qid="delete-client-cancel-button"
        >
          {{ $t('system.close') }}
        </b-button>
      </div>
    </b-modal>


    <!-- Cart modal -->
    <b-modal ref="cart-modal" hide-footer hide-header :size="size" modal-class="cart-modal" @hide="hideCartModal">
      <div class="row" v-if="!client.country">
        <div class="col-sm-12">
          <div class="d-block text-center">
            <h4 qid="delete-client-title">
              {{ $t('profile.client.billing.country_modal_title') }}
            </h4>
          </div>
          <b-form qid="report-form">
            <div class="form-container">
              <b-form-group>
                <div class="row">
                  <div class="col-md-12">
                    <label qid="create-client-name-label">
                      {{ $t('administration.clients.create.country_label') }}
                      <span class="text-red">*</span>
                    </label>
                    <multiselect
                        v-model="selectedCountry"
                        :options="countries"
                        :multiple="false"
                        :taggable="false"
                        track-by="name"
                        :select-label="$t('system.dropdown_select_label')"
                        :selected-label="$t('system.dropdown_selected_label')"
                        :deselect-label="$t('system.dropdown_deselect_label')"
                        :placeholder="''"
                        label="name"
                        qid="create-tp-countries-select"
                    >
                      <template slot="singleLabel" slot-scope="props">
                        <img v-bind:src="props.option.flag" height="13" class="align-baseline mr-1" />
                        <span class="ml-2">
                          {{ props.option.name }}
                        </span>
                      </template>
                      <template slot="option" slot-scope="props">
                        <img v-bind:src="props.option.flag" height="13" class="align-baseline mr-1" />
                        <span class="ml-2">
                          {{ props.option.name }}
                        </span>
                      </template>
                    </multiselect>
                  </div>
                </div>
              </b-form-group>
            </div>
            <div class="text-right">
              <b-button class="mt-2"
                        variant="secondary"
                        @click="hideCartModal"
                        qid="integrity-edit-cancel-button"
              >
                {{ $t('activities.integrity_check.cancel') }}
              </b-button>
              <b-button class="mt-2 ml-1 mr-0"
                        variant="success"
                        @click="countryFormSubmit"
                        qid="integrity-edit-submit-button"
              >
                {{ $t('activities.integrity_check.submit') }}
              </b-button>
            </div>
          </b-form>
        </div>
      </div>
      <div class="row" v-if="client.country">
        <div class="col-sm-8 p-2">
          <div class="d-block text-left mt-4">
            <h4 qid="update-tp-title">
              {{ $t('profile.client.billing.modal_title') }}
            </h4>
          </div>
          <hr>
          <div class="mt-4">
            <div class="row">
              <div class="col-sm-4">
                <small class="text-muted uppercase">
                  {{ $t('profile.client.billing.plan_label') }}
                </small>
              </div>
              <div class="col-sm-3">
                <small class="text-muted uppercase">
                  {{ $t('profile.client.billing.quantity_label') }}
                </small>
              </div>
              <div class="col-sm-3">
                <small class="text-muted uppercase">
                  {{ $t('profile.client.billing.price_label') }}
                </small>
              </div>
              <div class="col-sm-2">
                <small class="text-muted uppercase">
                  {{ $t('profile.client.billing.total_label') }}
                </small>
              </div>
            </div>

            <!-- Selected plan -->

            <div class="row mt-3" v-if="selectedPlan && selectedPlan.id">
              <div class="col-sm-4 fs-1">
                {{ selectedPlan.name }}
              </div>
              <div class="col-sm-3 fs-1">

              </div>
              <div class="col-sm-3 fs-1">

              </div>
              <div class="col-sm-2 fs-1" v-if="client && client.plan">
                <span v-if="client.subscription_status == 'trial' || client.subscription_status == 'trial_expired' || client.subscription_status == 'subscription_ended' || client.subscription_status == 'subscription_canceled'">
                  &euro; {{ selectedPlan.price }}
                </span>
                <span v-if="(client.subscription_status != 'trial' && client.subscription_status != 'trial_expired' && client.subscription_status != 'subscription_ended'  && client.subscription_status != 'subscription_canceled') && selectedPlan.name == client.plan.name">
                  &euro; 0
                </span>
                <span v-if="(client.subscription_status != 'trial' && client.subscription_status != 'trial_expired' && client.subscription_status != 'subscription_ended'  && client.subscription_status != 'subscription_canceled') && selectedPlan.name != client.plan.name">
                  &euro; {{ selectedPlan.price }}
                </span>
              </div>
            </div>

            <!-- Included modules -->

            <div class="mt-4">
              <small class="text-muted uppercase">
                {{ $t('profile.client.billing.modules_label') }}
              </small>
            </div>

            <div class="row mt-3" v-if="selectedPlan && selectedPlan.id && feature.module != 'admin'" v-for="feature in selectedPlan.features">
              <div class="col-sm-4 fs-1">
                {{ feature.name }}
                <br>
                <div class="text-muted text-normal" style="font-size:10px;margin-top:-2px;">
                  {{ $t('profile.client.billing.from_plan_label') }}
                </div>
              </div>
              <div class="col-sm-3 fs-1">

              </div>
              <div class="col-sm-3 fs-1">

              </div>
              <div class="col-sm-2 fs-1">
                &euro; 0
              </div>
            </div>

            <!-- Selected features -->

            <div class="row mt-3" v-if="selectedPlan && selectedPlan.id" v-for="(selectedFeature, selectedIndex) in selectedFeatures">
              <div class="col-sm-4 fs-1">
                {{ selectedFeature.name }}
                <br>
                <div class="text-muted text-normal" style="font-size:10px;margin-top:-2px;">
                  <span @click="removeFeature(selectedIndex, selectedFeature)" class="cursor-pointer remove-label">
                    {{ $t('profile.client.billing.remove_label') }}
                  </span>
                </div>
              </div>
              <div class="col-sm-3 fs-1">

              </div>
              <div class="col-sm-3 fs-1">

              </div>
              <div class="col-sm-2 fs-1">
                &euro; {{ selectedFeature.price }}
              </div>
            </div>

          </div>
        </div>
        <div class="col-sm-4 p-2">
          <span @click="hideCartModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <div class="d-block text-left mt-4">
            <h4 qid="update-tp-title">
              {{ $t('profile.client.billing.order_summary') }}
            </h4>
          </div>
          <hr>
          <div class="mt-4">
            <div class="row">
              <div class="col-sm-8 uppercase fs-1">
                {{ $t('profile.client.billing.shopping_cart_label') }}
              </div>
              <div class="col-sm-4 text-right fs-1">
                &euro; {{ totalPrice }}
              </div>
            </div>
            <hr>
            <div class="row mt-4">
              <div class="col-sm-8 uppercase fs-1">
                {{ $t('profile.client.billing.total_cost_label') }}
              </div>
              <div class="col-sm-4 text-right fs-1">
                &euro; {{ totalPrice }}
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12">
                <span class="btn btn-success btn-block cursor-pointer uppercase fs-1" @click="checkout()" :class="{'btn-disabled not-clickable': checkoutDisabled}">
                  {{ $t('profile.client.billing.checkout_label') }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>


      <!-- Hidden form element -->
      <form :action="'/api/clients/' + getClient.slug + '/checkout'" method="post" ref="form" style="visibility:hidden;height:1px;">
        <input type="text" id="admins" name="additional_admins" v-model="adminsAmount"><br>
        <input type="text" id="validators" name="additional_validators" v-model="validatorsAmount"><br>
        <input type="text" id="members" name="additional_members" v-model="membersAmount"><br>
        <input type="text" id="partitions" name="additional_partitions" v-model="partitionsAmount"><br>
        <input type="text" id="plan" name="plan" v-model="selectedPlan.id"><br>
        <input type="text" id="api_token" name="api_token" v-model="getToken"><br>
        <input type="text" id="token" name="token" v-model="getToken"><br>
        <input type="text" id="features" name="features" v-model="selectedFeaturesIds"><br>
        <input type="submit" value="Submit">
      </form>

    </b-modal>


    <!-- Add modules modal -->
    <b-modal ref="modules-modal" modal-class="task-modal mapping-modal" @hide="hideModulesModal">
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideModulesModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center">
            {{ $t('profile.client.billing.modules_modal_title') }}
          </h5>
        </div>
      </template>

      <div class="row">
        <div class="col-sm-6" v-for="(feature, index) in modalFeatures">
          <div class="section-container mt-2"
               :class="{'section-container-selected': feature.from_plan || feature.selected,
                        'section-container-unavailable': (feature.module == 'gdpr_advanced' && !isAvailable(feature)) || (feature.module == 'contract_advanced' && !isAvailable(feature)) || (feature.module == 'assessment' && !isAvailable(feature))}">
            <span style="height:40px;" class="float-left mr-2">
              <span @click="selectFeature(index, feature)" :class="{'not-clickable': feature.from_plan || ((feature.module == 'gdpr_advanced' && !isAvailable(feature)) || (feature.module == 'contract_advanced' && !isAvailable(feature)) || (feature.module == 'assessment' && !isAvailable(feature)))}" class="cursor-pointer">
                <font-awesome-icon :icon="['far', 'square']" style="color:#BCDAD4;margin-bottom:1px;" v-if="!feature.selected"/>
                <font-awesome-icon icon="check-square" style="color:#2DBA9B;margin-bottom:1px;" v-if="feature.selected && !feature.from_plan"/>
                <font-awesome-icon icon="check-square" style="color:#BCDAD4;margin-bottom:1px;" v-if="feature.selected && feature.from_plan"/>
              </span>
            </span>
            <span>
              <span class="text-normal">{{ feature.name }}</span>
              <br>
              <span class="text-bold" v-if="!feature.from_plan">&euro; {{ feature.price }}</span>
              <span class="text-muted" v-if="feature.from_plan">
                {{ $t('profile.client.billing.from_plan_label') }}
              </span>
            </span>
          </div>
        </div>
      </div>


      <template #modal-footer="{ close }">
        <div class="" style="width: 100%;">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class=""
                            variant="secondary"
                            @click="hideModulesModal"
                            qid="create-ac-cancel-button"
                  >
                    {{ $t('activities.system.create.cancel') }}
                  </b-button>
                  <b-button type="submit"
                            class="ml-3"
                            variant="success"
                            @click="addFeatures()"
                            :disabled="buttonDisabled"
                            qid="create-ac-submit-button"
                  >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                    {{ $t('profile.client.billing.add_selected_features') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>

    </b-modal>


    <!-- Edit report modal -->
    <b-modal ref="edit-report" hide-footer>
      <div class="d-block text-center">
        <h4 qid="edit-report-modal-title">
          <span>
            {{ $t('profile.client.edit_report_title') }}
          </span>
        </h4>
      </div>
      <b-alert v-if="reportForm.error && reportForm.error.length"
               show
               variant="danger"
               qid="edit-user-error"
      >
        {{ reportForm.error }}
      </b-alert>
      <b-form @submit="reportEditFormSubmit" qid="report-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-client-name-label">
              {{ $t('profile.client.report_name_label') }}
              <span class="text-red">*</span>
            </label>
            <b-form-input
              qid="create-user-form-name"
              type="text"
              v-model="reportForm.name"
              required
              :placeholder="$t('profile.client.report_name_label')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="create-client-cvr-label">
              {{ $t('profile.client.report_ctid_label') }}
              <span class="text-red">*</span>
            </label>
            <b-form-input
              qid="create-client-form-cvr"
              type="text"
              required
              v-model="reportForm.ctid"
              :placeholder="$t('profile.client.report_ctid_label')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="create-client-street-label">
              {{ $t('profile.client.report_id_label') }}
              <span class="text-red">*</span>
            </label>
            <b-form-input
              qid="create-client-form-street"
              type="text"
              required
              v-model="reportForm.reportId"
              :placeholder="$t('profile.client.report_id_label')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="create-clients-city-label">
              {{ $t('profile.client.report_page_name_label') }}
            </label>
            <b-form-input
              qid="create-clients-form-city"
              type="text"
              v-model="reportForm.pageName"
              :placeholder="$t('profile.client.report_page_name_label')"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideEditReportModal"
                    qid="edit-profile-cancel-button"
          >
            {{ $t('profile.password.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    variant="success"
                    :disabled="buttonDisabled"
                    qid="edit-profile-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('profile.password.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>


    <!-- Create report modal -->
    <b-modal ref="create-report" hide-footer>
      <div class="d-block text-center">
        <h4 qid="edit-report-modal-title">
          <span>
            {{ $t('profile.client.create_report_title') }}
          </span>
        </h4>
      </div>
      <b-alert v-if="reportForm.error && reportForm.error.length"
               show
               variant="danger"
               qid="edit-user-error"
      >
        {{ reportForm.error }}
      </b-alert>
      <b-form @submit="reportFormSubmit" qid="report-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-client-name-label">
              {{ $t('profile.client.report_name_label') }}
              <span class="text-red">*</span>
            </label>
            <b-form-input
              qid="create-user-form-name"
              type="text"
              v-model="reportForm.name"
              required
              :placeholder="$t('profile.client.report_name_label')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="create-client-cvr-label">
              {{ $t('profile.client.report_ctid_label') }}
              <span class="text-red">*</span>
            </label>
            <b-form-input
              qid="create-client-form-cvr"
              type="text"
              required
              v-model="reportForm.ctid"
              :placeholder="$t('profile.client.report_ctid_label')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="create-client-street-label">
              {{ $t('profile.client.report_id_label') }}
              <span class="text-red">*</span>
            </label>
            <b-form-input
              qid="create-client-form-street"
              type="text"
              required
              v-model="reportForm.reportId"
              :placeholder="$t('profile.client.report_id_label')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="create-clients-city-label">
              {{ $t('profile.client.report_page_name_label') }}
            </label>
            <b-form-input
              qid="create-clients-form-city"
              type="text"
              v-model="reportForm.pageName"
              :placeholder="$t('profile.client.report_page_name_label')"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideCreateReportModal"
                    qid="edit-profile-cancel-button"
          >
            {{ $t('profile.password.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    variant="success"
                    :disabled="buttonDisabled"
                    qid="edit-profile-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('profile.password.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>


    <!-- Edit domain modal -->
    <b-modal ref="edit-domain" hide-footer>
      <div class="d-block text-center">
        <h4 qid="edit-domain-modal-title">
          <span>
            {{ $t('profile.client.edit_domain_title') }}
          </span>
        </h4>
      </div>
      <b-alert v-if="domainForm.error && domainForm.error.length"
               variant="danger"
               show
               qid="edit-user-error"
      >
        {{ domainForm.error }}
      </b-alert>
      <b-form @submit="domainEditFormSubmit" qid="domain-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-client-name-label">
              {{ $t('profile.client.domain_label') }}
              <span class="text-red">*</span>
            </label>
            <b-form-input
              qid="create-user-form-name"
              type="text"
              v-model="domainForm.name"
              required
              :placeholder="$t('profile.client.domain_label')"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideEditDomainModal"
                    qid="edit-profile-cancel-button"
          >
            {{ $t('profile.password.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    variant="success"
                    :disabled="buttonDisabled"
                    qid="edit-profile-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('profile.password.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>


    <!-- Create domain modal -->
    <b-modal ref="create-domain" hide-footer>
      <div class="d-block text-center">
        <h4 qid="edit-report-modal-title">
          <span>
            {{ $t('profile.client.create_domain_title') }}
          </span>
        </h4>
      </div>
      <b-alert v-if="domainForm.error && domainForm.error.length"
               variant="danger"
               show
               qid="edit-user-error"
      >
        {{ domainForm.error }}
      </b-alert>
      <b-form @submit="domainFormSubmit" qid="report-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-client-name-label">
              {{ $t('profile.client.domain_label') }}
              <span class="text-red">*</span>
            </label>
            <b-form-input
              qid="create-user-form-name"
              type="text"
              v-model="domainForm.name"
              required
              :placeholder="$t('profile.client.domain_label')"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideCreateDomainModal"
                    qid="edit-profile-cancel-button"
          >
            {{ $t('profile.password.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    variant="success"
                    :disabled="buttonDisabled"
                    qid="edit-profile-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('profile.password.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>



    <!-- Delete client confirm modal template -->
    <b-modal ref="delete-client" hide-footer>
      <div class="d-block text-center">
        <h4 qid="delete-client-title">
          {{ $t('administration.clients.delete.title') }}
        </h4>
      </div>
      <h5 class="text-center">
        {{ $t('administration.clients.delete.token_description') }} {{ itemToDelete.name }}
      </h5>
      <h5 class="text-center">
        {{ $t('administration.clients.delete.are_you_sure') }}
      </h5>
      <div class="text-center">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideConfirmDeleteModal"
                  qid="delete-client-cancel-button"
        >
          {{ $t('administration.clients.delete.cancel') }}
        </b-button>
        <b-button @click="confirmDeleteClient(itemToDelete)"
                  class="mt-3 ml-3"
                  variant="success"
                  qid="delete-client-submit-button"
        >
          {{ $t('administration.clients.delete.submit') }}
        </b-button>
      </div>
    </b-modal>


    <!-- Delete domain modal template -->
    <b-modal ref="delete-domain" hide-footer>
      <div class="d-block text-center">
        <h4 qid="delete-report-title">
          {{ $t('maintenance.questions.delete.title') }}
        </h4>
      </div>
      <h5 class="text-center">
        {{ $t('maintenance.questions.delete.description') }}
        <span v-if="itemToDelete && itemToDelete.name">{{ itemToDelete.name }}</span>
      </h5>
      <h5 class="text-center">
        {{ $t('maintenance.questions.delete.are_you_sure') }}
      </h5>
      <div class="text-center">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideDomainConfirmDeleteModal"
                  qid="delete-question-cancel-button"
        >
          {{ $t('maintenance.questions.delete.cancel') }}
        </b-button>
        <b-button @click="confirmDeleteDomain(itemToDelete)"
                  class="mt-3 ml-3"
                  variant="success"
                  qid="delete-question-submit-button"
        >
          {{ $t('maintenance.questions.delete.submit') }}
        </b-button>
      </div>
    </b-modal>


    <!-- Delete report modal template -->
    <b-modal ref="delete-report" hide-footer>
      <div class="d-block text-center">
        <h4 qid="delete-report-title">
          {{ $t('maintenance.questions.delete.title') }}
        </h4>
      </div>
      <h5 class="text-center">
        {{ $t('maintenance.questions.delete.description') }}
        <span v-if="itemToDelete && itemToDelete.name">{{ itemToDelete.name }}</span>
      </h5>
      <h5 class="text-center">
        {{ $t('maintenance.questions.delete.are_you_sure') }}
      </h5>
      <div class="text-center">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideReportConfirmDeleteModal"
                  qid="delete-question-cancel-button"
        >
          {{ $t('maintenance.questions.delete.cancel') }}
        </b-button>
        <b-button @click="confirmDeleteReport(itemToDelete)"
                  class="mt-3 ml-3"
                  variant="success"
                  qid="delete-question-submit-button"
        >
          {{ $t('maintenance.questions.delete.submit') }}
        </b-button>
      </div>
    </b-modal>

    <!-- Delete subscription -->
    <b-modal ref="delete-subscription" hide-footer>
      <div>
        <div class="d-block text-center">
          <h4 qid="delete-report-title">
            {{ $t('profile.client.billing.unsubscribe_title') }}?
          </h4>
        </div>
        <hr />
        <p class="text-left mt-3">
          {{ $t('profile.client.billing.unsubscribe_description') }}
        </p>
        <p class="text-left">
          {{ $t('profile.client.billing.unsubscribe_question') }}
        </p>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideUnsubscribe()"
                    qid="delete-question-cancel-button"
          >
            {{ $t('maintenance.questions.delete.cancel') }}
          </b-button>
          <b-button @click="unsubscribeFunction()"
                    class="mt-3 ml-3"
                    variant="danger"
                    qid="delete-question-submit-button"
          >
            {{ $t('profile.client.billing.unsubscribe_title') }}
          </b-button>
        </div>
      </div>
    </b-modal>


    <!-- Unsubscribe success modal -->
    <b-modal ref="delete-subscription-success" hide-footer>
      <div class="text-center">
        <font-awesome-icon icon="heart-broken" size="10x" class="color-danger"/>
        <h4 class="mt-3">
          {{ $t('profile.client.billing.unsubscribe_success_title') }}
        </h4>
        <p class="text-left mt-3 text-muted">
          {{ $t('profile.client.billing.unsubscribe_success_description') }}
        </p>
        <div>
          <b-button @click="continueDeleteSubscription()"
                    class="mt-3 ml-3"
                    variant="success"
                    qid="delete-question-submit-button"
          >
            {{ $t('profile.client.billing.unsubscribe_success_continue') }}
          </b-button>
        </div>

      </div>
    </b-modal>


    <!-- Delete feature modal -->
    <b-modal ref="delete-feature" hide-footer>
      <div>
        <div class="d-block text-center">
          <h4 qid="delete-report-title">
            {{ $t('profile.client.billing.delete_feature_title') }}
          </h4>
        </div>
        <hr />
        <p class="text-left mt-3">
          {{ $t('profile.client.billing.delete_feature_first_description') }}
          <span v-if="featureToDelete && featureToDelete.name" class="text-success">
            {{ featureToDelete.name }}
          </span>
          <span>
            {{ $t('profile.client.billing.delete_feature_module_label') }}.
          </span>
          {{ $t('profile.client.billing.delete_feature_second_description') }}
        </p>
        <p class="text-left">
          {{ $t('profile.client.billing.delete_feature_question') }}
        </p>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideFeatureConfirmDeleteModal"
                    qid="delete-question-cancel-button"
          >
            {{ $t('maintenance.questions.delete.cancel') }}
          </b-button>
          <b-button @click="confirmDeleteFeature(featureToDelete)"
                    class="mt-3 ml-3"
                    variant="danger"
                    qid="delete-question-submit-button"
          >
            {{ $t('profile.client.billing.unsubscribe_title') }}
          </b-button>
        </div>
      </div>
    </b-modal>


    <!-- Resume subscription modal-->
    <b-modal ref="resume" hide-footer>
      <div>
        <div class="d-block text-center">
          <h4 qid="delete-report-title">
            {{ $t('profile.client.billing.resume_title') }}
          </h4>
        </div>
        <hr />
        <p class="text-left mt-3">
          {{ $t('profile.client.billing.resume_description') }}
        </p>
        <p class="text-left">
          {{ $t('profile.client.billing.resume_question') }}
        </p>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideResume"
                    qid="delete-question-cancel-button"
          >
            {{ $t('maintenance.questions.delete.cancel') }}
          </b-button>
          <b-button @click="confirmResume(selectedPlan)"
                    class="mt-3 ml-3"
                    variant="danger"
                    qid="delete-question-submit-button"
          >
            {{ $t('profile.client.billing.resume_button') }}
          </b-button>
        </div>
      </div>
    </b-modal>
    <b-modal ref="resume-success" hide-footer>
      <div class="text-center">
        <font-awesome-icon icon="rocket" size="10x" class="color-success"/>
        <h4 class="mt-3">{{ $t('profile.client.billing.resume_success_title') }}</h4>
        <p class="text-left mt-3 text-muted">
          {{ $t('profile.client.billing.resume_success_description', { name: selectedPlan.name}) }}
        </p>
        <div>
          <b-button @click="continueResume(selectedPlan)"
                    class="mt-3 ml-3"
                    variant="success"
                    qid="delete-question-submit-button"
          >
            {{ $t('profile.client.billing.resume_success_continue') }}
          </b-button>
        </div>

      </div>
    </b-modal>


    <!-- delete feature success modal -->
    <b-modal ref="delete-feature-success" hide-footer>
      <div class="text-center">
        <font-awesome-icon icon="puzzle-piece" size="10x" class="color-danger"/>
        <h4 class="mt-3">
          {{ $t('profile.client.billing.delete_feature_success_title') }}
        </h4>
        <p class="text-left mt-3 text-muted">
          {{ $t('profile.client.billing.delete_feature_success_first_description') }}
          <span v-if="featureToDelete && featureToDelete.name" class="text-danger text-normal">
            {{ featureToDelete.name }}
          </span>
          <span>
            {{ $t('profile.client.billing.delete_feature_module_label') }}.
          </span>
          {{ $t('profile.client.billing.delete_feature_success_second_description') }}
        </p>
        <div>
          <b-button @click="continueDeleteFeature(featureToDelete)"
                    class="mt-3 ml-3"
                    variant="success"
                    qid="delete-question-submit-button"
          >
            {{ $t('profile.client.billing.unsubscribe_success_continue') }}
          </b-button>
        </div>

      </div>
    </b-modal>


    <!-- Add feature success modal -->
    <b-modal ref="subscription-feature-success" hide-footer>
      <div class="text-center">
        <font-awesome-icon icon="puzzle-piece" size="10x" class="color-success"/>
        <h4 class="mt-3" v-if="featureToSubscription.module != 'admin' && featureToSubscription.module != 'validator' && featureToSubscription.module != 'member' && featureToSubscription.module != 'partition'">
          {{ $t('profile.client.billing.add_feature_title') }}
        </h4>
        <h4 class="mt-3" v-if="featureToSubscription.module == 'admin' || featureToSubscription.module == 'validator' || featureToSubscription.module == 'member' || featureToSubscription.module == 'partition'">
          {{ $t('profile.client.billing.update_feature_title') }}
        </h4>
        <p class="text-left mt-3 text-muted" v-if="featureToSubscription.module != 'admin' && featureToSubscription.module != 'validator' && featureToSubscription.module != 'member' && featureToSubscription.module != 'partition'">
          {{ $t('profile.client.billing.add_feature_first_description') }}
          <span v-if="featureToSubscription && featureToSubscription.name" class="text-success text-normal">
            {{ featureToSubscription.name }}
          </span>
          <span>
            {{ $t('profile.client.billing.delete_feature_module_label') }}.
          </span>
        </p>

        <p class="text-left mt-3 text-muted" v-if="featureToSubscription.module == 'admin' || featureToSubscription.module == 'validator' || featureToSubscription.module == 'member' || featureToSubscription.module == 'partition'">
          {{ $t('profile.client.billing.quantity_feature_description') }}
          <span v-if="featureToSubscription && featureToSubscription.name" class="text-success text-normal">
            {{ featureToSubscription.name }}
          </span>
          <span>
            {{ $t('profile.client.billing.delete_feature_module_label') }}.
          </span>
        </p>
        <div>
          <b-button @click="continueSubscriptionFeature(featureToSubscription)"
                    class="mt-3 ml-3"
                    variant="success"
                    qid="delete-question-submit-button"
          >
            {{ $t('profile.client.billing.unsubscribe_success_continue') }}
          </b-button>
        </div>

      </div>
    </b-modal>


    <!-- Checkout success modal -->
    <b-modal ref="checkout-success" hide-footer>
      <div class="text-center">
        <font-awesome-icon icon="rocket" size="10x" class="color-success"/>
        <h4 class="mt-3">
          {{ $t('profile.client.billing.checkout_success_title') }}
        </h4>
        <p class="mt-3 text-muted">
          {{ $t('profile.client.billing.checkout_success_description') }}
        </p>
        <div>
          <b-button @click="hideCheckoutSuccessModal()"
                    class="mt-3 ml-3 uppercase"
                    variant="success"
                    qid="delete-question-submit-button"
          >
            {{ $t('profile.client.billing.unsubscribe_success_continue') }}
          </b-button>
        </div>

      </div>
    </b-modal>


    <!-- Subscription to feature -->
    <b-modal size="xl" ref="subscription-feature" hide-footer>
      <div class="d-block text-left">
        <div class="row">
          <div class="col-md-7">
            <h4 qid="delete-report-title">
              {{ $t('profile.client.billing.shopping_cart') }}
            </h4>
            <hr />
          </div>
          <div class="col-md-4 offset-md-1">
            <h4 qid="delete-report-title">
              {{ $t('profile.client.billing.order_summary') }}
            </h4>
            <hr />
          </div>
        </div>

        <div class="row">
          <div class="col-md-7">
            <div class="text-left mt-3">
              {{ $t('features.'+featureToSubscription.module) }}
            </div>

            <div class="row mt-4" v-if="client && client.plan && client.plan == 'Enterprise' || (featureToSubscription.module != 'admin' && featureToSubscription.module != 'validator' && featureToSubscription.module != 'member' && featureToSubscription.module != 'partition')">
              <div class="col-md-9">
                <div class="text-muted">{{ $t('profile.client.billing.feature_name') }}</div>
                <h5 class="text-lg-left mt-2">{{ featureToSubscription.name }}</h5>
              </div>
              <div class="col-md-3" v-if="client.plan != 'Enterprise'">
                <div class="text-muted text-right">{{ $t('profile.client.billing.total') }}</div>
                <h5 class="text-lg-right mt-2">&euro; {{ featureToSubscription.price }}</h5>
              </div>
            </div>

            <div class="row mt-4" v-if="client && client.plan && client.plan != 'Enterprise' && featureToSubscription.module == 'admin'">
              <div class="col-md-3">
                <div class="text-muted">{{ $t('profile.client.billing.feature_name') }}</div>
                <h5 class="text-lg-left mt-2">{{ featureToSubscription.name }}</h5>
              </div>
              <div class="col-md-3">
                <div class="text-muted text-center">{{ $t('profile.client.billing.quantity') }}</div>
                <div class="text-lg-center mt-2">
                  <font-awesome-icon icon="minus" class="cursor-pointer " @click="decreaseAdmins"/>
                  <span class="cart-number-input">
                  {{ adminsAmount }}
                  </span>
                  <font-awesome-icon icon="plus" class="cursor-pointer" @click="increaseAdmins"/>
                </div>
              </div>
              <div class="col-md-3">
                <div class="text-muted text-right">{{ $t('profile.client.billing.price') }}</div>
                <h5 class="text-lg-right mt-2">&euro; {{ adminFeature.price }}</h5>
              </div>
              <div class="col-md-3">
                <div class="text-muted text-right">{{ $t('profile.client.billing.total') }}</div>
                <h5 class="text-lg-right mt-2">&euro; {{ (adminsAmount - client.admin_limit) * adminFeature.price }}</h5>
              </div>
            </div>

            <div class="row mt-4" v-if="client && client.plan && client.plan != 'Enterprise' && featureToSubscription.module == 'partition'">
              <div class="col-md-3">
                <div class="text-muted">{{ $t('profile.client.billing.feature_name') }}</div>
                <h5 class="text-lg-left mt-2">{{ featureToSubscription.name }}</h5>
              </div>
              <div class="col-md-3">
                <div class="text-muted text-center">{{ $t('profile.client.billing.quantity') }}</div>
                <div class="text-lg-center mt-2">
                  <font-awesome-icon icon="minus" class="cursor-pointer " @click="decreasePartitions"/>
                  <span class="cart-number-input">
                  {{ partitionsAmount }}
                  </span>
                  <font-awesome-icon icon="plus" class="cursor-pointer" @click="increasePartitions"/>
                </div>
              </div>
              <div class="col-md-3">
                <div class="text-muted text-right">{{ $t('profile.client.billing.price') }}</div>
                <h5 class="text-lg-right mt-2">&euro; {{ partitionFeature.price }}</h5>
              </div>
              <div class="col-md-3">
                <div class="text-muted text-right">{{ $t('profile.client.billing.total') }}</div>
                <h5 class="text-lg-right mt-2">&euro; {{ (partitionsAmount - client.partition_limit) * partitionFeature.price }}</h5>
              </div>
            </div>

            <div class="row mt-4" v-if="client && client.plan && client.plan != 'Enterprise' && featureToSubscription.module == 'validator'">
              <div class="col-md-3">
                <div class="text-muted">{{ $t('profile.client.billing.feature_name') }}</div>
                <h5 class="text-lg-left mt-2">{{ featureToSubscription.name }}</h5>
              </div>
              <div class="col-md-3">
                <div class="text-muted text-center">{{ $t('profile.client.billing.quantity') }}</div>
                <div class="text-lg-center mt-2">
                  <font-awesome-icon icon="minus" class="cursor-pointer " @click="decreaseValidators"/>
                  <span class="cart-number-input">
                  {{ validatorsAmount }}
                  </span>
                  <font-awesome-icon icon="plus" class="cursor-pointer" @click="increaseValidators"/>
                </div>
              </div>
              <div class="col-md-3">
                <div class="text-muted text-right">{{ $t('profile.client.billing.price') }}</div>
                <h5 class="text-lg-right mt-2">&euro; {{ validatorFeature.price }}</h5>
              </div>
              <div class="col-md-3">
                <div class="text-muted text-right">{{ $t('profile.client.billing.total') }}</div>
                <h5 class="text-lg-right mt-2">&euro; {{ (validatorsAmount - client.validator_limit) * validatorFeature.price }}</h5>
              </div>
            </div>

            <div class="row mt-4" v-if="client && client.plan && client.plan != 'Enterprise' && featureToSubscription.module == 'member'">
              <div class="col-md-3">
                <div class="text-muted">{{ $t('profile.client.billing.feature_name') }}</div>
                <h5 class="text-lg-left mt-2">{{ featureToSubscription.name }}</h5>
              </div>
              <div class="col-md-3">
                <div class="text-muted text-center">{{ $t('profile.client.billing.quantity') }}</div>
                <div class="text-lg-center mt-2">
                  <font-awesome-icon icon="minus" class="cursor-pointer " @click="decreaseMembers"/>
                  <span class="cart-number-input">
                  {{ membersAmount }}
                  </span>
                  <font-awesome-icon icon="plus" class="cursor-pointer" @click="increaseMembers"/>
                </div>
              </div>
              <div class="col-md-3">
                <div class="text-muted text-right">{{ $t('profile.client.billing.price') }}</div>
                <h5 class="text-lg-right mt-2">&euro; {{ memberFeature.price }}</h5>
              </div>
              <div class="col-md-3">
                <div class="text-muted text-right">{{ $t('profile.client.billing.total') }}</div>
                <h5 class="text-lg-right mt-2">&euro; {{ (membersAmount - client.member_limit) * memberFeature.price }}</h5>
              </div>
            </div>

            <div class="row" v-if="userMessage">
              <div class="col-md-12">
                <span class="text-danger">{{userMessage}}</span>
              </div>
            </div>
          </div>

          <div class="col-md-4 offset-md-1" v-if="client && client.plan">
            <div class="row h6" v-if="client.plan != 'Enterprise'">
              <div class="col-md-9">{{ $t('profile.client.billing.existing_monthly_price') }}</div>
              <div class="col-md-3">&euro; {{ client.subscription_total }}</div>
            </div>
            <div class="row h6" v-if="client.plan != 'Enterprise'">
              <div class="col-md-9">{{ $t('profile.client.billing.added_monthly_price') }}</div>
              <div class="col-md-3" v-if="featureToSubscription.module != 'admin' && featureToSubscription.module != 'validator' && featureToSubscription.module != 'member' && featureToSubscription.module != 'partition'">&euro; {{ featureToSubscription.price }}</div>
              <div class="col-md-3" v-if="featureToSubscription.module == 'admin'">&euro; {{ (adminsAmount - client.admin_limit) * adminFeature.price }}</div>
              <div class="col-md-3" v-if="featureToSubscription.module == 'member'">&euro; {{ (membersAmount - client.member_limit) * memberFeature.price }}</div>
              <div class="col-md-3" v-if="featureToSubscription.module == 'validator'">&euro; {{ (validatorsAmount - client.validator_limit) * validatorFeature.price }}</div>
              <div class="col-md-3" v-if="featureToSubscription.module == 'partition'">&euro; {{ (partitionsAmount - client.partition_limit) * partitionFeature.price }}</div>
            </div>
            <hr v-if="client.plan != 'Enterprise'"/>
            <div class="row h6" v-if="client.plan != 'Enterprise'">
              <div class="col-md-9">{{ $t('profile.client.billing.total_monthly_price') }}</div>
              <div class="col-md-3" v-if="featureToSubscription.module != 'admin' && featureToSubscription.module != 'validator' && featureToSubscription.module != 'member' && featureToSubscription.module != 'partition'">&euro; {{ featureToSubscription.price + client.subscription_total }}</div>
              <div class="col-md-3" v-if="featureToSubscription.module == 'admin'">&euro; {{ (adminsAmount - client.admin_limit) * adminFeature.price + client.subscription_total }}</div>
              <div class="col-md-3" v-if="featureToSubscription.module == 'member'">&euro; {{ (membersAmount - client.member_limit) * memberFeature.price + client.subscription_total }}</div>
              <div class="col-md-3" v-if="featureToSubscription.module == 'validator'">&euro; {{ (validatorsAmount - client.validator_limit) * validatorFeature.price + client.subscription_total }}</div>
              <div class="col-md-3" v-if="featureToSubscription.module == 'partition'">&euro; {{ (partitionsAmount - client.partition_limit) * partitionFeature.price + client.subscription_total }}</div>
            </div>
            <div class="mt-5"  v-if="client.plan != 'Enterprise'">
              <b-button @click="confirmSubscriptionFeature(featureToSubscription)"
                        class="mt-3 w-100"
                        :class="{'btn-disabled': membersAmount == client.member_limit}"
                        variant="success"
                        qid="delete-question-submit-button"
                        v-if="featureToSubscription.module == 'member'"
              >
                {{ $t('profile.client.billing.checkout_label') }}
              </b-button>
              <b-button @click="confirmSubscriptionFeature(featureToSubscription)"
                        class="mt-3 w-100"
                        :class="{'btn-disabled': partitionsAmount == client.partition_limit}"
                        variant="success"
                        qid="delete-question-submit-button"
                        v-if="featureToSubscription.module == 'partition'"
              >
                {{ $t('profile.client.billing.checkout_label') }}
              </b-button>
              <b-button @click="confirmSubscriptionFeature(featureToSubscription)"
                        class="mt-3 w-100"
                        :class="{'btn-disabled': adminsAmount == client.admin_limit}"
                        variant="success"
                        qid="delete-question-submit-button"
                        v-if="featureToSubscription.module == 'admin'"
              >
                {{ $t('profile.client.billing.checkout_label') }}
              </b-button>
              <b-button @click="confirmSubscriptionFeature(featureToSubscription)"
                        class="mt-3 w-100"
                        :class="{'btn-disabled': validatorsAmount == client.validator_limit}"
                        variant="success"
                        qid="delete-question-submit-button"
                        v-if="featureToSubscription.module == 'validator'"
              >
                {{ $t('profile.client.billing.checkout_label') }}
              </b-button>

              <b-button @click="confirmSubscriptionFeature(featureToSubscription)"
                        class="mt-3 w-100"
                        variant="success"
                        qid="delete-question-submit-button"
                        v-if="featureToSubscription.module != 'admin' && featureToSubscription.module != 'validator' && featureToSubscription.module != 'member' && featureToSubscription.module != 'partition'"
              >
                {{ $t('profile.client.billing.checkout_label') }}
              </b-button>
            </div>
            <div class="mt-1"  v-if="client.plan == 'Enterprise'">
              <b-button @click="goToContactPage()"
                        class="mt-3 w-100"
                        variant="success"
                        qid="delete-question-submit-button"
              >
                {{ $t('profile.client.billing.contact_us_label') }}
              </b-button>
            </div>
          </div>
        </div>
      </div>

    </b-modal>


    <!-- Crop image modal -->
    <b-modal ref="crop-image" hide-footer size="lg">
      <div class="d-block text-center">
        <h4 qid="edit-profile-modal-title">
          {{ $t('system.crop_image') }}
        </h4>
      </div>
      <div class="form-container" style="max-height: 600px;">
        <img v-bind:src="imageToCrop"
             qid="profile-photo"
             id="crop"
        >
      </div>
      <div class="text-right">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideCropModal"
                  qid="edit-profile-cancel-button"
        >
          {{ $t('profile.password.cancel') }}
        </b-button>
        <b-button type="submit"
                  class="mt-3 ml-3"
                  variant="success"
                  id="crop-button"
                  :disabled="buttonDisabled"
                  qid="edit-profile-submit-button"
        >
          <span v-if="buttonDisabled" class="mr-1">
            <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
          </span>
          {{ $t('profile.password.submit') }}
        </b-button>
      </div>
    </b-modal>

  </div>
</template>

<script>
import piincHttp from '@/util/configureAxios.js'
import {config} from '@/config.js'
import draggable from 'vuedraggable'
import Avatar from '@/components/Avatar.vue';
import roleCheck from "@/util/ACL/roleCheck"

import VueCropper from 'vue-cropperjs';
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';


export default {
  name: 'ClientProfile',
  data: function() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('dashboard.title'),
          to: '/'
        }
      ],
      clientForm: {
        name: '',
        cvr: '',
        street: '',
        city: '',
        state: '',
        postcode: '',
        country: '',
        email: '',
        reference_number: '',
        notification: '',
        website:''
      },
      clientLogoForm: {
        file: {}
      },
      countryForm: {
        country: ''
      },
      reportForm: {
        name: '',
        ctid: '',
        reportId: '',
        pageName: ''
      },
      domainForm: {
        name: ''
      },
      features: [],
      plans: [],
      selectedPlan: {},
      riskTypeOptions: [
        { value: 'single_risk', name: 'Single risk' },
        { value: 'cia_risk', name: 'CIA risk' }
      ],
      tableItems: [],
      loading: true,
      error: '',
      buttonDisabled: false,
      client: {},
      tabIndex: 0,
      showRiskForm: false,
      selectedRiskType: [],
      showPowerBiForm: false,
      reportToken: '',
      itemToDelete: {},
      featureToDelete: {},
      featureToSubscription: {},
      itemToRefresh: {},
      selectedToken: '',
      selectedReport: {},
      showForm: false,
      domainTableItems: [],
      selectedDomain: [],
      totalPrice: 0,
      validatorFeature: {},
      memberFeature: {},
      adminFeature: {},
      partitionFeature: {},

      adminsAmount: 0,
      membersAmount: 0,
      validatorsAmount: 0,
      partitionsAmount: 0,

      avatar: '',
      avatarLarge: '',
      imageToCrop: '',
      cropper: {},

      selectedFeatures: [],
      selectedModalFeatures: [],
      modalFeatures: [],
      selectedFeaturesIds: [],
      checkoutDisabled: false,
      userMessage: '',
      countries: [],
      selectedCountry: [],
      invoices: {},
      loadingInvoices: false,
      size: 'xl',
      itemToEnterprise: {}
    }
  },
  computed: {
    getClient() {
      return this.$store.state.client
    },
    getUser() {
      return this.$store.state.user
    },
    getTotalPrice() {
      return this.totalPrice
    },
    getClientAvatar(){
      let client = this.client;
      if (client.logo) {
        return client.logo;
      } else {
        return require('@/assets/tp-logo.png');
      }
    },
    getToken() {
      return this.$store.state.token
    },
  },
  watch: {
    getClient: function (newValue, oldValue) {
      if (newValue && oldValue && newValue.slug && oldValue.slug) {
        if (this.$route.name == 'administration.clientView') {
          this.$router.push('/')
        } else {
          this.$router.push({ name: 'clientProfile', params: { slug: newValue.slug }})
        }
        this.avatarLarge = this.getClientAvatar;
      }
    },
  },
  components: {
    Avatar,
    VueCropper,
    draggable
  },
  methods: {
    loadCountries() {
      let self = this;
      piincHttp.get('countries-with-flag').then(function(response) {
        self.countries = response.data

        if (self.client.country) {
          _.find(self.countries, function(item) {
            if (item.name === self.client.country) {
              self.client.country_with_flag = item
            }
          });
        }

      }, function() {});
    },
    showCropModal() {
      let sizeError = false;
      let self = this

      this.$refs['crop-image'].show()
      this.buttonDisabled = false;

      setTimeout(function(){
        const image = document.getElementById('crop');
        const cropper = new Cropper(image, {
          aspectRatio: 1,
          viewMode: 2,
          crop(event) {

          },
        });

        document.getElementById('crop-button').addEventListener('click', function(){
          self.buttonDisabled = true;

          cropper.getCroppedCanvas().toBlob(function (blob) {
            var formData = new FormData();
            formData.append('croppedImage', blob);

            if (blob.size > 10485760) {
              sizeError = true;
            }

            formData.append("logo", blob);
            formData.append("_method", 'put');

            if (sizeError) {
              self.error = self.$t('system.file_size')
              alert(self.error)
            } else {
              piincHttp.post('clients/' + self.client.slug, formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              }).then(function(response) {
                  self.hideCropModal()
                  window.location.reload()
              }, function(error) {
                self.buttonDisabled = false;
                self.clientLogoForm.error = error.data.message;
                if (error.data.errors.logo) {
                  self.clientLogoForm.error += ' ' + error.data.errors.logo[0]
                }
                alert(self.clientLogoForm.error)
              })
            }

          });

        })
      }, 500);

    },
    hideCropModal() {
      this.loadClient()
      this.$refs['crop-image'].hide()
    },
    onFileChange(file) {
      this.clientLogoForm.file = file;
      const avatar = file.target.files[0];
      this.avatar = URL.createObjectURL(avatar);
      this.avatarLarge = URL.createObjectURL(avatar);
      this.imageToCrop = URL.createObjectURL(avatar);

      this.showCropModal()

    },
    removePhoto() {
      let self = this;
      let formData = new FormData();
      formData.append("logo", null);
      formData.append("_method", 'put');

      piincHttp.post('clients/' + this.client.slug, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function(response) {
        self.client = response.data
        window.location.reload()
        self.avatar = '';
      }, function(error) {})
    },
    resetFile() {
      let imagefile = document.querySelector('#file-photo');
      imagefile.value = '';
    },
    showConfirmEnterpriseModal(object) {
      this.itemToEnterprise = object
      this.$refs['enterprise-client'].show()
    },
    hideConfirmEnterpriseModal() {
      this.itemToEnterprise = {};
      this.$refs['enterprise-client'].hide()
    },
    confirmEnterpriseClient(client) {
      let self = this;
      piincHttp.post('clients/' + client.slug + '/enterprise').then(function(response) {
        self.hideConfirmEnterpriseModal();
        self.breadcrumbItems.pop();
        self.loadClient();
        // Trigger toastr message after modal close
        self.$toastr('success', self.$t('administration.clients.enterprise.success'))
      }, function() {

      });
    },
    showPowerBiFormFunction() {
      this.showPowerBiForm = true;
      let self = this;
      self.reportToken = self.client.report_token;
    },
    goToContactPage() {
      window.open('https://complyon.com/contact-form/', '_blank')
    },
    checkout() {
      this.checkoutDisabled = true
      this.$refs.form.submit()
    },
    isAvailable(feature) {
      let available = false;

      if (feature.module == 'gdpr_advanced') {
        if (this.modalFeatures[2].selected) {
          available = true
        }
      }
      if (feature.module == 'contract_advanced') {
        if (this.modalFeatures[4].selected) {
          available = true
        }
      }
      if (feature.module == 'assessment') {
        if (this.modalFeatures[6].selected) {
          available = true
        }
      }

      return available;
    },

    decreaseMembers() {
      if (this.membersAmount > 0) {
        if(this.client.user_counts.member < this.membersAmount){
          this.membersAmount -= 1
          this.totalPrice -= this.memberFeature.price
          this.userMessage = '';
        }else{
          this.userMessage = this.$t('profile.client.billing.user_message', { count: this.client.user_counts.member, role: "Member" })
        }
      }
    },
    increaseMembers() {
      this.membersAmount += 1
      this.totalPrice += this.memberFeature.price
    },
    decreaseAdmins() {
      if (this.adminsAmount > 1) {
        if(this.client.user_counts.admin < this.adminsAmount){
          this.adminsAmount -= 1
          this.totalPrice -= this.adminFeature.price
          this.userMessage = '';
        }else{
          this.userMessage = this.$t('profile.client.billing.user_message', { count: this.client.user_counts.admin, role: "Admin" })
        }
      }
    },
    increaseAdmins() {
      this.adminsAmount += 1
      this.totalPrice += this.adminFeature.price
    },
    decreaseValidators() {
      if (this.validatorsAmount > 0) {
        if (this.client.user_counts.validator < this.validatorsAmount) {
          this.validatorsAmount -= 1
          this.totalPrice -= this.validatorFeature.price
          this.userMessage = '';
        } else {
          this.userMessage = this.$t('profile.client.billing.user_message', { count: this.client.user_counts.validator, role: "Validator" })
        }
      }
    },
    increaseValidators() {
      this.validatorsAmount += 1
      this.totalPrice += this.validatorFeature.price
    },
    decreasePartitions() {
      if (this.partitionsAmount > 0) {
        if (this.client.user_counts.partition < this.partitionsAmount) {
          this.partitionsAmount -= 1
          this.totalPrice -= this.partitionFeature.price
          this.userMessage = '';
        } else {
          this.userMessage = this.$t('profile.client.billing.partition_message', { count: this.client.user_counts.partition })
        }
      }
    },
    increasePartitions() {
      this.partitionsAmount += 1
      this.totalPrice += this.partitionFeature.price
    },
    showUnsubscribe() {
      let self = this;
      this.$refs['delete-subscription'].show()
    },
    hideUnsubscribe() {
      let self = this;
      this.$refs['delete-subscription'].hide()
    },
    unsubscribeFunction() {
      let self = this;
      piincHttp.delete('clients/' + this.$route.params.slug + '/subscription').then(function() {
        self.$refs['delete-subscription'].hide();
        self.$refs['delete-subscription-success'].show();
      }, function() {});
    },
    continueDeleteSubscription(){
      let self = this;
      this.$refs['delete-subscription-success'].hide()
      window.location.href = '/client/' + this.client.slug + '?tabindex=1';
    },
    confirmDeleteSubscription(object) {
      let self = this;
      piincHttp.delete('clients/' + this.$route.params.slug + '/features/'+object.id).then(function() {
        self.$refs['delete-feature'].hide();
        self.$refs['delete-feature-success'].show();
      }, function() {});
    },
    checkIfAdmin() {
      if (roleCheck('Client admin') || roleCheck('Partition admin') || this.getUser.isAdmin) {
        return true
      } else {
        return false
      }
    },
    cancelRiskForm() {
      this.showPowerBiForm = false;
      let self = this;
      self.reportToken = '';
    },
    formRiskTypeSubmit() {
      let self = this;
      piincHttp.put('clients/' + this.$route.params.slug, {
        report_token: this.reportToken ? this.reportToken : ''
      }).then(function(response) {
        self.client = response.data;
        self.showPowerBiForm = false;
      }, function(error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
    },
    reportFormSubmit(evt) {
      this.buttonDisabled = true;
      let formData = new FormData();

      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;
      evt.preventDefault();

      formData.append("client", this.$route.params.slug);
      formData.append("name", this.reportForm.name);
      formData.append("ctid", this.reportForm.ctid);
      formData.append("report_id", this.reportForm.reportId);
      formData.append("page_name", this.reportForm.pageName);

      piincHttp.post('dashboards', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function(response) {
        self.$toastr('success', self.$t('profile.client.report_create_success'))
        self.hideCreateReportModal();
        self.loadReports();
        self.buttonDisabled = false;
      }, function(error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
    },
    reportEditFormSubmit(evt) {
      this.buttonDisabled = true;

      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;
      evt.preventDefault();

      let form = {};

      form.name = this.reportForm.name
      form.ctid = this.reportForm.ctid
      form.report_id = this.reportForm.reportId
      form.page_name = this.reportForm.pageName

      piincHttp.put('dashboards/' + this.selectedReport.slug, form).then(function(response) {
        self.$toastr('success', self.$t('profile.client.report_edit_success'))
        self.hideEditReportModal();
        self.loadReports();
        self.buttonDisabled = false;
      }, function(error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
    },
    showCreateReportModal(object) {
      this.reportForm.name = '';
      this.reportForm.ctid = '';
      this.reportForm.reportId = '';
      this.reportForm.pageName = '';
      this.$refs['create-report'].show()
    },
    hideCreateReportModal() {
      this.reportForm.name = '';
      this.reportForm.ctid = '';
      this.reportForm.reportId = '';
      this.reportForm.pageName = '';
      this.$refs['create-report'].hide()
    },
    showEditReportModal(object) {
      this.selectedReport = object
      this.reportForm.name = object.name;
      this.reportForm.ctid = object.ctid;
      this.reportForm.reportId = object.report_id;
      this.reportForm.pageName = object.page_name;
      this.$refs['edit-report'].show()
    },
    hideEditReportModal() {
      this.selectedReport = {};
      this.reportForm.name = '';
      this.reportForm.ctid = '';
      this.reportForm.reportId = '';
      this.reportForm.pageName = '';
      this.$refs['edit-report'].hide()
    },
    domainFormSubmit(evt) {
      this.buttonDisabled = true;
      let formData = new FormData();

      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;
      evt.preventDefault();

      formData.append("domain", this.domainForm.name);

      piincHttp.post('clients/' + this.$route.params.slug + '/domains', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function(response) {
        self.$toastr('success', self.$t('profile.client.domain_create_success'))
        self.hideCreateDomainModal();
        self.loadDomains();
        self.buttonDisabled = false;
      }, function(error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.domainForm.error = error.data.message;
          if (error.data.errors.domain) {
            self.domainForm.error = self.domainForm.error + '\n\n' + error.data.errors.domain[0];
          }
        }
      })
    },
    domainEditFormSubmit(evt) {
      this.buttonDisabled = true;

      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;
      evt.preventDefault();

      let form = {};

      form.domain = this.domainForm.name

      piincHttp.put('clients/' + this.$route.params.slug + '/domains/' + this.selectedDomain.id, form).then(function(response) {
        self.$toastr('success', self.$t('profile.client.domain_edit_success'))
        self.hideEditDomainModal();
        self.loadDomains();
        self.buttonDisabled = false;
      }, function(error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
          if (error.data.errors.domain) {
            self.domainForm.error = self.domainForm.error + '\n\n' + error.data.errors.domain[0];
          }
        }
      })
    },
    showCreateDomainModal(object) {
      this.domainForm.name = '';
      this.domainForm.error = '';
      this.$refs['create-domain'].show()
    },
    hideCreateDomainModal() {
      this.domainForm.name = '';
      this.domainForm.error = '';
      this.$refs['create-domain'].hide()
    },
    showEditDomainModal(object) {
      this.selectedDomain = object
      this.domainForm.name = object.domain;
      this.domainForm.error = '';
      this.$refs['edit-domain'].show()
    },
    hideEditDomainModal() {
      this.domainForm.name = '';
      this.domainForm.error = '';
      this.selectedDomain = []
      this.$refs['edit-domain'].hide()
    },
    showRefreshClientModal(object) {
      this.itemToRefresh = object
      this.$refs['refresh-client'].show()
    },
    hideRefreshClientModal() {
      this.itemToRefresh = {};
      this.$refs['refresh-client'].hide()
    },
    showDomainConfirmDeleteModal(object) {
      this.itemToDelete = object
      this.$refs['delete-domain'].show()
    },
    hideDomainConfirmDeleteModal() {
      this.itemToDelete = {};
      this.$refs['delete-domain'].hide()
    },
    confirmDeleteDomain(object) {
      let self = this;

      piincHttp.delete('clients/' + this.$route.params.slug + '/domains/' + object.id).then(function() {
        self.hideDomainConfirmDeleteModal();
        self.loadDomains();
        // Trigger toastr message after modal close
        self.$toastr('success', self.$t('profile.client.domain_delete_success'))
      }, function() {

      });
    },
    showConfirmDeleteModal(object) {
      this.itemToDelete = object
      this.$refs['delete-client'].show()
    },
    hideConfirmDeleteModal() {
      this.itemToDelete = {};
      this.$refs['delete-client'].hide()
    },
    confirmDeleteClient(client) {
      let self = this;

      piincHttp.put('clients/' + this.$route.params.slug, {
        api_token: ''
      }).then(function(response) {
        self.client = response.data;
        self.hideConfirmDeleteModal();
        // Trigger toastr message after modal close
        self.$toastr('success', self.$t('administration.clients.delete.token_success'))
      }, function() {

      });
    },
    showClientTokenModal(object) {
      this.selectedToken = object
      this.$refs['client-token'].show()
    },
    hideClientTokenModal() {
      this.selectedToken = '';
      this.$refs['client-token'].hide()
    },
    showCartModal(object) {
      let self = this;
      this.selectedPlan = object
      this.checkoutDisabled = false;
      this.featureToSubscription = {}

      _.find(this.features, function(item) {
        if (item.module === 'admin') {
          self.adminFeature = item;
        }
      });
      _.find(this.features, function(item) {
        if (item.module === 'partition') {
          self.partitionFeature = item;
        }
      });
      _.find(this.features, function(item) {
        if (item.module === 'member') {
          self.memberFeature = item;
        }
      });
      _.find(this.features, function(item) {
        if (item.module === 'validator') {
          self.validatorFeature = item;
        }
      });

      this.totalPrice = this.selectedPlan.price
      if(!this.client.country){
        this.size = 'xs';
      }
      this.$refs['cart-modal'].show()
    },
    showResume(object) {
      let self = this;
      this.selectedPlan = object
      this.checkoutDisabled = false;

      this.$refs['resume'].show()
    },
    hideResume(object) {
      let self = this;
      this.selectedPlan = object
      this.checkoutDisabled = false;

      this.$refs['resume'].hide()
    },
    confirmResume(object) {
      let self = this;
      piincHttp.post('clients/' + this.$route.params.slug + '/subscription/resume').then(function() {
        self.$refs['resume'].hide();
        self.$refs['resume-success'].show();
      }, function() {});
    },
    continueResume(){
      let self = this;
      this.selectedPlan = {}
      this.$refs['resume-success'].hide()
      window.location.href = '/client/' + this.client.slug + '?tabindex=1';
    },
    hideCartModal() {
      this.selectedPlan = '';
      this.selectedFeaturesIds = [];
      this.selectedFeatures = [];
      this.totalPrice = 0;

      this.adminsAmount = this.client.admin_limit;
      this.membersAmount = this.client.member_limit;
      this.validatorsAmount = this.client.validator_limit;
      this.partitionsAmount = this.client.partition_limit;
      this.$refs['cart-modal'].hide()
    },
    showModulesModal() {
      let self = this;
      this.modalFeatures = [];
      this.selectedModalFeatures = []

      _.forEach(this.features, function (feature, index) {
        feature.selected = false
        feature.from_plan = false;
      })

      _.forEach(this.features, function (feature, index) {
        if (feature.module == 'processing_activities') {
          self.modalFeatures.push(feature)
        }
      })
      _.forEach(this.features, function (feature, index) {
        if (feature.module == 'system') {
          self.modalFeatures.push(feature)
        }
      })
      _.forEach(this.features, function (feature, index) {
        if (feature.module == 'gdpr') {
          self.modalFeatures.push(feature)
        }
      })
      _.forEach(this.features, function (feature, index) {
        if (feature.module == 'gdpr_advanced') {
          self.modalFeatures.push(feature)
        }
      })
      _.forEach(this.features, function (feature, index) {
        if (feature.module == 'contract_basic') {
          self.modalFeatures.push(feature)
        }
      })
      _.forEach(this.features, function (feature, index) {
        if (feature.module == 'contract_advanced') {
          self.modalFeatures.push(feature)
        }
      })
      _.forEach(this.features, function (feature, index) {
        if (feature.module == 'project') {
          self.modalFeatures.push(feature)
        }
      })
      _.forEach(this.features, function (feature, index) {
        if (feature.module == 'assessment') {
          self.modalFeatures.push(feature)
        }
      })
      _.forEach(this.features, function (feature, index) {
        if (feature.module == 'policy') {
          self.modalFeatures.push(feature)
        }
      })
      _.forEach(this.features, function (feature, index) {
        if (feature.module == 'risk_control') {
          self.modalFeatures.push(feature)
        }
      })

      this.selectedModalFeatures =  _.cloneDeep(this.selectedFeatures);

      _.forEach(this.modalFeatures, function (feature, index) {
        _.find(self.client.features, function(planFeature) {
          if (planFeature.id == feature.id) {
            feature.from_plan = true;
            feature.selected = true;
          }
        });
        _.find(self.selectedModalFeatures, function(modalFeature) {
          if (modalFeature.id == feature.id) {
            feature.selected = true;
          }
        });
        self.$set(self.modalFeatures, index, feature)
      })

      this.$refs['modules-modal'].show()
    },
    hideModulesModal() {
      this.selectedModalFeatures = [];
      this.$refs['modules-modal'].hide()
    },
    selectFeature(index, item) {
      let self = this;
      item.selected = item.selected ? false : true;
      if (item.selected) {
        this.selectedModalFeatures.push(item)
      } else {
        let itemIndex = _.findIndex(this.selectedModalFeatures, function(o) { return o.id == item.id; });
        this.selectedModalFeatures.splice(itemIndex, 1);
      }

      this.$set(this.modalFeatures, index, item)
    },
    addFeatures() {
      let self = this;

      _.forEach(this.selectedModalFeatures, function (feature, index) {
        if (_.findIndex(self.selectedFeatures, function(o) { return o.id == feature.id }) == -1) {
          self.totalPrice += feature.price
        }
      })

      _.forEach(this.selectedFeatures, function (feature, index) {
        if (_.findIndex(self.selectedModalFeatures, function(o) { return o.id == feature.id }) == -1) {
          self.totalPrice -= feature.price
        }
      })

      this.selectedFeatures = _.cloneDeep(this.selectedModalFeatures);

      _.forEach(this.selectedFeatures, function (feature, index) {
        self.selectedFeaturesIds.push(feature.id)
      })
      this.hideModulesModal()
    },
    removeFeature(index, feature) {
      this.selectedFeatures.splice(index, 1);
      this.totalPrice -= feature.price;
    },
    showReportConfirmDeleteModal(object) {
      this.itemToDelete = object
      this.$refs['delete-report'].show()
    },
    hideReportConfirmDeleteModal() {
      this.itemToDelete = {}
      this.$refs['delete-report'].hide()
    },
    showFeatureConfirmDeleteModal(object) {
      this.featureToDelete = object
      this.$refs['delete-feature-success'].hide();
      this.$refs['delete-feature'].show()
    },
    hideFeatureConfirmDeleteModal() {
      this.featureToDelete = {}
      this.$refs['delete-feature'].hide()
    },
    showFeatureConfirmSubscriptionModal(object) {
      this.adminsAmount = this.client.admin_limit;
      this.membersAmount = this.client.member_limit;
      this.validatorsAmount = this.client.validator_limit;
      this.partitionsAmount = this.client.partition_limit;
      this.featureToSubscription = object
      this.userMessage = ''
      this.$refs['subscription-feature-success'].hide();
      this.$refs['subscription-feature'].show()
    },
    hideFeatureConfirmSubscriptionModal() {
      this.featureToSubscription = {}
      this.$refs['subscription-feature'].hide()
    },
    showCheckoutSuccessModal() {
      this.$refs['checkout-success'].show()
    },
    hideCheckoutSuccessModal() {
      this.featureToSubscription = {}
      this.$refs['checkout-success'].hide()
    },
    confirmDeleteReport(object) {
      let self = this;
      piincHttp.delete('dashboards/' + object.slug).then(function() {
        self.hideReportConfirmDeleteModal();
        self.loadReports();
        // Trigger toastr message after modal close
        self.$toastr('success', self.$t('profile.client.report_delete_success'))
      }, function() {});
    },
    continueDeleteFeature(){
      let self = this;
      this.featureToDelete = {}
      this.$refs['delete-feature-success'].hide()
      window.location.href = '/client/' + this.client.slug + '?tabindex=1';
    },
    confirmDeleteFeature(object) {
      let self = this;
      piincHttp.delete('clients/' + this.$route.params.slug + '/features/'+object.id).then(function() {
        self.$refs['delete-feature'].hide();
        self.$refs['delete-feature-success'].show();
      }, function() {});
    },
    confirmSubscriptionFeature(object, quantity = 0) {
      let self = this;

      if (object.module === 'admin') {
        quantity = this.adminsAmount;
      } else if (object.module === 'member') {
        quantity = this.membersAmount;
      } else if (object.module === 'validator') {
        quantity = this.validatorsAmount;
      } else if (object.module === 'partition') {
        quantity = this.partitionsAmount;
      } else {
        quantity = 0
      }

      piincHttp.post('clients/' + this.$route.params.slug + '/features', {
        feature: object.id,
        quantity: quantity
      }).then(function() {
        self.$refs['subscription-feature'].hide();
        self.$refs['subscription-feature-success'].show();
      }, function() {});
    },
    continueSubscriptionFeature(){
      let self = this;
      this.featureToSubscription = {}
      this.$refs['subscription-feature-success'].hide()
      window.location.href = '/client/' + this.client.slug + '?tabindex=1';
    },
    confirmRefreshClient(client) {
      let self = this;

      piincHttp.get('clients/' + this.$route.params.slug + '/generate-token').then(function(response) {
        self.client = response.data.client;
        self.hideRefreshClientModal();
        self.showClientTokenModal(response.data.token);
        // Trigger toastr message after modal close
        self.$toastr('success', self.$t('administration.clients.refresh.success'))
      }, function() {

      });
    },
    postOrder() {
      let self = this;
      let order = []
      _.forEach(this.tableItems, function (item, index) {
        order.push({
          id: item.id,
          position: index + 1
        });
      })
      piincHttp.post('dashboards/order', {
        client: this.client.id,
        order: order
      }).then(function(response) {
      }, function(error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
    },
    showRiskFormFunction() {
      this.showRiskForm = true;
      let self = this;

      _.find(this.riskTypeOptions, function(item) {
        if (item.value === self.client.risk_type) {
          self.selectedRiskType = item;
        }
      });

    },
    cancelRiskForm() {
      this.showRiskForm = false;
      let self = this;

      _.find(this.riskTypeOptions, function(item) {
        if (item.value === self.client.risk_type) {
          self.selectedRiskType = item;
        }
      });
    },
    formRiskTypeSubmit() {
      let self = this;
      piincHttp.put('clients/' + this.client.slug, {
        risk_type: this.selectedRiskType ? this.selectedRiskType.value : ''
      }).then(function(response) {
        let client = response.data;
        self.buttonDisabled = false;

        if (self.client.slug != client.slug) {
          localStorage.removeItem('client')
          piincHttp.get('users/me/permissions/' + client.slug).then(function(response) {
            client.user_permissions = response.data.user_permissions
            client.user_roles = response.data.user_roles
            localStorage.setItem('clientObject', JSON.stringify(client));
            localStorage.setItem('client', client.slug);
            self.$store.commit('storeClient', client);
            self.showRiskForm = false;
            window.location.reload();
          }, function() {});
        } else {
          window.location.reload();
        }
      }, function(error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
    },
    showFormFunction() {
      let self = this;
      this.clientForm.name = this.client.name;
      this.clientForm.cvr = this.client.cvr;
      this.clientForm.reference_number = this.client.reference_number;
      this.clientForm.website = this.client.website;
      this.clientForm.street = this.client.street;
      this.clientForm.city = this.client.city;
      this.clientForm.state = this.client.state;
      this.clientForm.postcode = this.client.postcode;

      if (this.client.country) {
        this.selectedCountry = { name: this.client.country }
      }

      this.selectedCountry = [];
      if (this.client.country) {
        _.find(this.countries, function(item) {
          if (item.name === self.client.country) {
            self.selectedCountry = item
          }
        });
      }

      this.clientForm.country = this.client.country;
      this.clientForm.notification = this.client.notification;
      this.clientForm.error = '';
      this.showForm = true;
    },
    hideFormFunction() {
      this.showForm = false;
    },
    clientFormSubmit() {
      this.buttonDisabled = true;
      let self = this;

      this.clientForm.country = '';
      if (this.selectedCountry && this.selectedCountry.name) {
        this.clientForm.country = this.selectedCountry.name
      }

      if (this.selectedCountry && this.selectedCountry.name) {
        piincHttp.put('clients/' + this.client.slug, this.clientForm).then(function(response) {
          let client = response.data;
          self.buttonDisabled = false;
          self.hideFormFunction();
          self.breadcrumbItems.pop();
          if (self.$route.name == 'administration.clientView') {
            // Additional removing of breadcrumb items if administration
            self.breadcrumbItems.pop();
            self.breadcrumbItems.pop();
          }
          self.loadClient();

        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.clientForm.error = error.data.message;
          }
        })
      } else {
        this.clientForm.error = this.$t('system.country_error_message')
        this.buttonDisabled = false;
      }

    },
    countryFormSubmit() {
      this.buttonDisabled = true;
      let self = this;

      this.countryForm.country = '';
      if (this.selectedCountry && this.selectedCountry.name) {
        this.countryForm.country = this.selectedCountry.name
      }

      if (this.selectedCountry && this.selectedCountry.name) {
        piincHttp.put('clients/' + this.client.slug, this.countryForm).then(function(response) {
          let client = response.data;
          self.buttonDisabled = false;
          self.hideFormFunction();
          self.breadcrumbItems.pop();
          self.loadClient(true);
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.clientForm.error = error.data.message;
          }
        })
      } else {
        this.clientForm.error = this.$t('system.country_error_message')
        this.buttonDisabled = false;
      }

    },
    showEditNameProfileModal() {
      this.clientForm.name = this.client.name;
      this.clientForm.cvr = this.client.cvr;
      this.clientForm.reference_number = this.client.reference_number;
      this.clientForm.street = this.client.street;
      this.clientForm.city = this.client.city;
      this.clientForm.state = this.client.state;
      this.clientForm.postcode = this.client.postcode;
      this.clientForm.country = this.client.country;
      this.clientForm.notification = this.client.notification;
      this.clientForm.error = '';
      this.$refs['edit-profile-name'].show()
    },
    hideEditNameProfileModal() {
      this.$refs['edit-profile-name'].hide()
    },
    clientNameFormSubmit(evt) {
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;
      evt.preventDefault();

      piincHttp.put('clients/' + this.client.slug, this.clientForm).then(function(response) {
        let client = response.data;
        self.buttonDisabled = false;

        localStorage.removeItem('client')
        piincHttp.get('users/me/permissions/' + client.slug).then(function(response) {
          client.user_permissions = response.data.user_permissions
          client.user_roles = response.data.user_roles
          localStorage.setItem('clientObject', JSON.stringify(client));
          localStorage.setItem('client', client.slug);
          self.$store.commit('storeClient', client);
          self.hideEditNameProfileModal();

          if (self.$route.name == 'administration.clientView') {
            self.$router.push({ name: 'administration.clientView', params: { slug: client.slug }})
          } else {
            self.$router.push({ name: 'clientProfile', params: { slug: client.slug }})
          }

          window.location.reload()
        }, function() {});

      }, function(error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.clientForm.error = error.data.message;
        }
      })
    },
    loadReports() {
      let self = this;

      piincHttp.get('dashboards', { params:
        {
          page: 1,
          per_page: 1,
          client: this.client.slug
        }
      }).then(function(response) {
        let total = response.data.total_count

        piincHttp.get('dashboards', { params:
          {
            page: 1,
            per_page: total,
            client: self.client.slug
          }
        }).then(function(response) {
          self.loading = false;
          self.tableItems = response.data.items;
        }, function() {});
      }, function() {});
    },
    loadDomains() {
      let self = this;

      piincHttp.get('clients/' + this.$route.params.slug + '/domains', { params:
        {
          page: 1,
          per_page: 1
        }
      }).then(function(response) {
        self.domainTableItems = response.data.items
      }, function() {});
    },
    loadFeatures() {
      let self = this;

      piincHttp.get('features', { params: {
        per_page: 100
      }}).then(function(response) {
        self.features = response.data.items;

        _.find(self.features, function(item) {
          if (item.module === 'admin') {
            self.adminFeature = item;
          }
        });
        _.find(self.features, function(item) {
          if (item.module === 'partition') {
            self.partitionFeature = item;
          }
        });
        _.find(self.features, function(item) {
          if (item.module === 'member') {
            self.memberFeature = item;
          }
        });
        _.find(self.features, function(item) {
          if (item.module === 'validator') {
            self.validatorFeature = item;
          }
        });

      }, function() {});
    },
    loadPlans() {
      let self = this;

      piincHttp.get('plans', { params: {
        per_page: 100
      }}).then(function(response) {
        self.plans = response.data.items;
      }, function() {});
    },
    loadClient(forceBigModal) {
      let self = this;

      piincHttp.get('clients/' + this.$route.params.slug, { params:
        {
          full: 1
        }
      }).then(function(response) {
        self.client = response.data
        self.membersAmount = self.client.member_limit;
        self.adminsAmount = self.client.admin_limit;
        self.validatorsAmount = self.client.validator_limit;
        self.partitionsAmount = self.client.partition_limit;

        if (forceBigModal) {
          self.size = 'xl';
        }

        self.loadReports()

        if (self.countries && self.countries.length) {
          if (self.client.country) {
            _.find(self.countries, function(item) {
              if (item.name === self.client.country) {
                self.client.country_with_flag = item
              }
            });
          }
        }

        if (self.$route.name == 'administration.clientView') {
          self.breadcrumbItems.push({
            text: self.$t('administration.title'),
            to: '/administration'
          })
          self.breadcrumbItems.push({
            text: self.$t('administration.clients.title'),
            to: '/administration/clients'
          })
          self.breadcrumbItems.push({text: self.client.name, active: true});
        } else {
          if (self.client.parent) {
            self.breadcrumbItems.push({
              text: self.$t('profile.partition_profile'),
              active: true
            })
          } else {
            self.breadcrumbItems.push({
              text: self.$t('profile.client_profile'),
              active: true
            })
          }
        }

      }, function() {});
    },
    loadClientInvoices() {
      let self = this;
      this.loadingInvoices = true;

      piincHttp.get('clients/' + this.$route.params.slug + '/invoices').then(function(response) {
        self.invoices = response.data
        self.loadingInvoices = false;
      }, function() {});
    },
    notificationSwitch(type) {
      let self = this;
      piincHttp.put('clients/' + this.client.slug, {notification: type}).then(function(response) {
        let client = response.data;
        self.client.notification = response.data.notification
      }, function(error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.clientForm.error = error.data.message;
        }
      })
    },
    checkAdmin(role) {
      let hasRole = false;
      let user = this.$store.state.user;
      if (user.isAdmin) {
        hasRole = true;
      }
      // Return Boolean if user has given role
      return hasRole;
    }
  },
  created () {
    let self = this;

    setTimeout(function() {
      if (self.$route.query.tabindex) {
        self.tabIndex = parseInt(self.$route.query.tabindex, 10)
      }
    }, 500);

    setTimeout(function() {
      if (self.$route.query.modal && self.$route.query.modal == 'success') {
        self.showCheckoutSuccessModal()
      }
    }, 800);


    this.loadClient()
    this.loadFeatures()
    this.loadPlans()
    this.loadDomains()
    this.loadCountries()
    this.loadClientInvoices();
  }
}
</script>
